import {
  ArrowLeft,
  Edit,
  FileText,
  Bed,
  Bath,
  Car,
  Calendar,
  View,
  MapPin,
  Phone,
  Mail,
  User,
  Tag,
  Eye,
  Trash2,
  Plus,
  Archive,
  PauseCircle,
  CheckCircle2,
  XCircle,
  UploadCloud,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Building2,
  ExternalLink,
  Users2,
  X,
  MessageSquare,
  DollarSign,
  Copy,
  UserPlus,
  SlidersHorizontal,
  Send,
  Edit2,
} from "lucide-react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import {
  Badge,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "../../../components/ui";
import PropertyDocumentsPage from "../../../components/properties/ViewDocuments";
import PropertyActivityLog from "../components/PropertyActivityLog";
import ComplianceTab from "../../compliance/components/ComplianceTab";
import ComplianceChecklistCard from "../../compliance/components/ComplianceChecklistCard";
import { isPriceReasonRequired, usePriceChangeReason } from "../../compliance/components/PriceChangeReasonModal";
import PublicMatchBadge from "../components/PublicMatchBadge";
import CampaignSwitch from "../components/CampaignSwitch";
import { useEffect, useState } from "react";
import {
  getCollingsProperty,
  updateCollingsProperty,
  patchCollingsProperty,
  reorderCollingsPropertyImages,
  deleteCollingsProperty,
  uploadCollingsPropertyFloorplan,
  deleteCollingsPropertyFloorplan,
} from "../../../api/collingsProperties";
import {
  addAdditionalOwner,
  deleteAdditionalOwner,
} from "../../../api/publicApi";
import { getInspections, sendContractOfSale, getBulkSmsPayload, markSmsHandedOff, patchAttendee } from "../../../api/inspection";
import BulkCommunicatorModal from "../../inspections/components/BulkCommunicatorModal";
import EditAttendeeModal from "../../../components/properties/modals/EditAttendeeModal";
import ContactNotesButton from "../../contacts/components/ContactNotesButton";
import BuyerPreferencesModal from "../../contacts/components/BuyerPreferencesModal";
import ContactLink from "../../contacts/components/ContactLink";
import {
  getAgents,
  getPropertyNotes,
  createPropertyNote,
  deletePropertyNote,
  getPropertyDocuments,
  uploadStatementOfInfo,
  deletePropertyDocument,
  getProperties,
  markPropertyListed,
} from "../../../api/agent";
import {
  getPropertyEnquiries,
  updateEnquiry,
  getPropertyBidderRegistrations,
  getMatchedBuyersForREAProperty,
  getPropertyOffers,
  getPropertyVendorStatus,
  resendPropertyVendorInvite,
  confirmMutualAcceptance,
  updateOffer,
  getPropertyBulkSmsPayload,
  markPropertyBulkSmsHandedOff,
  getPropertyBulkEmailPayload,
  markPropertyBulkEmailHandedOff,
} from "../../../api/propertyManagement";
import { ignoreLead } from "../../../api/lead";
import SendToVendorModal from "../../offers/components/SendToVendorModal";
import SendToBuyerModal from "../../offers/components/SendToBuyerModal";
import CounterToBuyerModal from "../../offers/components/CounterToBuyerModal";
import OfferTimelineModal from "../../offers/components/OfferTimelineModal";
import { offerStatusPillClasses, offerStatusLabel } from "../../offers/utils/offerStatusStyles";
import { calculateBond } from "../utils/rentBond";
import LeadPreviewModal from "../../../components/leads/LeadPreviewModal";
import { getContacts, inviteContactToPortal } from "../../../api/contact";
import { withdrawREAPropertyFromREA, createREAProperty, publishREAPropertySoldToPortals } from "../../../api/rea";
import { useSelector } from "react-redux";
import LazyImage from "../../../components/common/LazyImage";
import toast from "react-hot-toast";
import DomainDescriptionCounter from "../../../components/common/DomainDescriptionCounter";
import { domainWarningsFromResponse } from "../../../utils/domainDescription";
import { notifyDomainResult } from "../../../utils/domainPublishToast";
import {
  SUPPORTED_UPLOAD_ACCEPT,
  splitSupportedUploads,
  rejectedUploadsMessage,
} from "../../../utils/imageUploadGuard";
import ConfirmModal from "../../../components/common/ConfirmModal";
import PropertyWithdrawControls from "../../../components/common/PropertyWithdrawControls";
import MarkSoldModal from "../../../components/common/MarkSoldModal";
import { promptPublishSold } from "../../../components/common/publishSoldPrompt";
import { buildSaleDetailsPatch, contractDateOf, defaultSoldDate } from "../utils/saleDetails";
import PublishSoldToPortalsModal from "../../../components/common/PublishSoldToPortalsModal";
import SoldThroughPortalToggle from "../../../components/common/SoldThroughPortalToggle";
import AddOwnerModal from "../../../components/properties/modals/AddOwnerModal";
import AddPurchaserModal from "../../../components/properties/modals/AddPurchaserModal";
import DuplicatePropertyModal from "../../../components/properties/modals/DuplicatePropertyModal";
import { useRef } from "react";
import ManageGalleryDialog from "../../../components/properties/ManageGalleryDialog";
import { applyImageOrder } from "../../../utils/propertyImages";
import { invalidateCache } from "../../../lib/cache";
import { hasAdminAccess } from "../../../utils/roleAccess";
import {
  formatMelbourneDatePart,
  formatMelbourneTimePart,
  datetimeLocalToUtcISOString,
  formatMelbourneDateTime,
} from "../../../utils/melbourneTime";
import AgentNotesPanel from "../../../components/notes/AgentNotesPanel";
import { ownerCommsParams } from "../../../components/notes/commsTimeline";
import { fetchCommunicationTimeline } from "../../communications/api/communicationsApi";

// Helpers
const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString(undefined, { style: "currency", currency: "AUD" });
};

const formatPrice = (price) => {
  if (!price) return null;
  const num = Number(price);
  if (isNaN(num)) return price;
  return `$${Math.round(num).toLocaleString()}`;
};

// Get price type label from price_display
const getPriceTypeLabel = (priceDisplay) => {
  const labels = {
    exact: "Asking Price",
    range: "Price Range",
    contact: "Contact Agent",
    auction: "Guided Price",
  };
  return labels[priceDisplay] || "Asking Price";
};

// Format price display with type label
const formatPriceDisplay = (property) => {
  if (!property) return "N/A";

  const priceDisplay = property.price_display || "exact";
  const priceTypeLabel = getPriceTypeLabel(priceDisplay);

  // Always use the actual price value, not price_display_text
  // Get price value (check both price and price_from)
  const priceValue = property.price || property.price_from;

  // Price Range: Show "Price Range: value-value"
  if (priceDisplay === "range") {
    const priceTo = property.price_to;
    if (priceValue && priceTo && Number(priceTo) !== Number(priceValue)) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)} – ${formatPrice(priceTo)}`;
    } else if (priceValue) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
    }
    return `${priceTypeLabel}`;
  }

  // Contact Agent: Show only "Contact Agent" (no value)
  if (priceDisplay === "contact") {
    return `${priceTypeLabel}`;
  }

  // Auction: Show "Guided Price: value" if price exists
  if (priceDisplay === "auction") {
    if (priceValue) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
    }
    return `${priceTypeLabel}`;
  }

  // Asking Price (exact): Show "Asking Price: value"
  if (priceDisplay === "exact") {
    if (priceValue) {
      return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
    }
    return `${priceTypeLabel}: Contact Agent`;
  }

  // Fallback
  if (!priceValue) {
    return `${priceTypeLabel}: Contact Agent`;
  }

  return `${priceTypeLabel}: ${formatPrice(priceValue)}`;
};

const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString();
  } catch (e) {
    return iso;
  }
};

const getStatusColor = (status) => {
  const s = String(status || "").toLowerCase();
  if (["for sale", "sale", "active", "under contract"].includes(s)) {
    return "bg-green-100 text-green-700";
  }
  if (["for rent", "rent", "rent out"].includes(s)) {
    return "bg-purple-100 text-purple-700";
  }
  if (["pending"].includes(s)) {
    return "bg-yellow-100 text-yellow-700";
  }
  if (["sold", "leased"].includes(s)) {
    return "bg-blue-100 text-blue-700";
  }
  if (["withdrawn"].includes(s)) {
    return "bg-slate-200 text-slate-700";
  }
  return "bg-slate-100 text-slate-700";
};

export default function CollingsPropertyDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const { requestReason: requestPriceReason, reasonModal: priceReasonModal } = usePriceChangeReason();
  const [property, setProperty] = useState(null);
  const isLease = property?.transaction_type === 'lease';
  // Commercial listings publish to realcommercial.com.au (via the REA feed)
  // instead of the residential realestate.com.au feed, so the Visibility panel
  // and the publish control swap to Real Commercial for them.
  const isCommercial = ['commercial', 'business'].includes(
    String(property?.property_type || '').toLowerCase()
  ) || String(property?.property_class || '').toLowerCase() === 'commercial'
    || String(property?.listing_type || '').toLowerCase() === 'commercial';
  const [isLoading, setIsLoading] = useState(true);
  // Enquiry/attendee whose buying preferences are being edited (null = closed).
  const [prefsPerson, setPrefsPerson] = useState(null);
  const [error, setError] = useState(null);
  // Restore the tab / enquiries sub-tab from the URL so returning here from a
  // contact profile (via its Back arrow) lands on the same place (Monday
  // 13056279356).
  const _initialParams = new URLSearchParams(location.search);
  const _rawInitialTab = _initialParams.get('tab') || 'property';
  const _rawSubTab = _initialParams.get('subtab');
  const _validSubTabs = ['enquiries', 'attendees', 'buyers', 'offers'];
  const [activeTab, setActiveTab] = useState(
    _rawInitialTab === 'offers' ? 'enquiries' : _rawInitialTab
  );
  const [owners, setOwners] = useState([]);
  const [purchasers, setPurchasers] = useState([]);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [isEditingInfo, setIsEditingInfo] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [descriptionEdit, setDescriptionEdit] = useState("");
  const [editForm, setEditForm] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [agents, setAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [isMarkingSold, setIsMarkingSold] = useState(false);
  const [isMarkingListed, setIsMarkingListed] = useState(false);
  const [showSoldModal, setShowSoldModal] = useState(false);
  const [showPublishSoldModal, setShowPublishSoldModal] = useState(false);
  // "Edit Sale Details" on a sold property: same dialog, saves without
  // toggling the sold state.
  const [showEditSaleModal, setShowEditSaleModal] = useState(false);
  const [isSavingSale, setIsSavingSale] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [showPurchaserModal, setShowPurchaserModal] = useState(false);
  const [editingPurchaser, setEditingPurchaser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [soiUploading, setSoiUploading] = useState(false);
  const soiFileInputRef = useRef(null);

  // Second agent: selection and "Make Secondary on Listing?" (co_agent only when ticked)
  const [secondAgentId, setSecondAgentId] = useState("");
  const [makeSecondaryAgentOnListing, setMakeSecondaryAgentOnListing] =
    useState(false);

  useEffect(() => {
    if (property) {
      const coId =
        property?.co_agent?.id ??
        property?.extra_info?.co_agent?.id ??
        property?.co_agent ??
        "";
      setSecondAgentId(coId ? String(coId) : "");
      setMakeSecondaryAgentOnListing(!!coId);
    }
  }, [property?.id, property?.co_agent, property?.extra_info?.co_agent]);

  // Buyer Portal Interactions State
  const [enquiries, setEnquiries] = useState([]);
  const [propertyNotes, setPropertyNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [ownerComms, setOwnerComms] = useState([]);
  const [bidderRegistrations, setBidderRegistrations] = useState([]);
  const [inspectionAttendees, setInspectionAttendees] = useState([]);
  const [sendingContractAttendeeId, setSendingContractAttendeeId] = useState(null);
  const [invitingAttendeeId, setInvitingAttendeeId] = useState(null);
  const [showBulkCommunicator, setShowBulkCommunicator] = useState(false);
  const [bulkContext, setBulkContext] = useState('attendees');
  const [editingAttendee, setEditingAttendee] = useState(null);
  const [enquiriesSubTab, setEnquiriesSubTab] = useState(
    _rawInitialTab === 'offers'
      ? 'offers'
      : (_validSubTabs.includes(_rawSubTab) ? _rawSubTab : 'enquiries')
  );
  const [interactionsLoading, setInteractionsLoading] = useState(false);
  const [editingEnquiry, setEditingEnquiry] = useState(null);
  const [enquiryEditMessage, setEnquiryEditMessage] = useState("");
  const [enquiryEditAgentNotes, setEnquiryEditAgentNotes] = useState("");
  const [isUpdatingEnquiry, setIsUpdatingEnquiry] = useState(false);

  const [offers, setOffers] = useState([]);
  const [offersLoading, setOffersLoading] = useState(false);
  const [viewingOffer, setViewingOffer] = useState(null);
  const [isUpdatingOffer, setIsUpdatingOffer] = useState(false);

  // Phase 1 — explicit "park before send" actions
  const [sendingToVendor, setSendingToVendor] = useState(null); // offer object or null
  const [sendingToBuyer, setSendingToBuyer] = useState(null);   // offer object or null
  const [counteringToBuyer, setCounteringToBuyer] = useState(null); // offer object or null
  const [vendorStatus, setVendorStatus] = useState(null);       // { state, vendor, owner_email }
  const [resendingVendorInvite, setResendingVendorInvite] = useState(false);

  // Phase 5 — mutual acceptance / Under Contract finalisation
  const [finalizingOffer, setFinalizingOffer] = useState(null); // offer object or null
  const [finalizing, setFinalizing] = useState(false);

  // Phase 4 — full event timeline modal
  const [timelineOffer, setTimelineOffer] = useState(null); // offer object or null

  // "Decline Offer" straight off this tab — id of the offer being declined
  const [decliningOfferId, setDecliningOfferId] = useState(null);

  // Buyer Matching State
  const [buyerMatches, setBuyerMatches] = useState([]);
  const [buyerMatchesLoading, setBuyerMatchesLoading] = useState(false);

  // Gallery Management
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [updatingGallery, setUpdatingGallery] = useState(false);
  const fileInputRef = useRef(null);
  const uploadPhotosRef = useRef(null);
  const targetImageForReplacement = useRef(null);

  // Full-size photo viewer. The gallery tiles are aspect-square crops, so
  // there was no way to actually LOOK at a photo from this page - clicking a
  // tile did nothing and the only affordance was the replace pencil.
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    if (lightboxIndex === null) return undefined;
    const count = property?.images?.length || 0;
    const onKey = (e) => {
      if (e.key === "Escape") setLightboxIndex(null);
      else if (e.key === "ArrowRight" && count > 1)
        setLightboxIndex((i) => (i + 1) % count);
      else if (e.key === "ArrowLeft" && count > 1)
        setLightboxIndex((i) => (i - 1 + count) % count);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightboxIndex, property?.images?.length]);

  // Floorplan tab (Manage Gallery dialog) - REA allows at most 2, separate
  // from the regular Images gallery (partner.realestate.com.au/listing-upload/
  // elements/#floorplan)
  const [uploadingFloorplan, setUploadingFloorplan] = useState(false);
  const floorplanInputRef = useRef(null);

  const [messagingBuyer, setMessagingBuyer] = useState(false);

  const handleMessageBuyer = async (email) => {
    if (!email) {
      toast.error("No email address provided for this buyer.");
      return;
    }
    try {
      setMessagingBuyer(true);
      const res = await getContacts({ search: email });
      const contacts = res.data?.results || res.data || [];
      const contact = contacts[0];

      if (contact) {
        navigate(`/contacts/${contact.id}?tab=communications`);
      } else {
        toast.error(
          "Contact not found for this email address. Please search manually in the Contacts section.",
        );
      }
    } catch (err) {
      console.error("Failed to find contact", err);
      toast.error("An error occurred while trying to find the contact.");
    } finally {
      setMessagingBuyer(false);
    }
  };

  // Email this single attendee the property's Contract of Sale. Reuses the same
  // BE endpoint as the open-home session screen, scoped to one attendee.
  const handleSendContractToAttendee = async (att) => {
    if (!att?.email) {
      toast.error("This buyer has no email on file to send the contract to.");
      return;
    }
    if (!att.inspection_id) {
      toast.error("Could not determine the inspection for this buyer.");
      return;
    }
    if (
      !window.confirm(
        `Send the Contract of Sale to ${att.name || att.email}?`,
      )
    )
      return;
    setSendingContractAttendeeId(att.id);
    try {
      const res = await sendContractOfSale(att.inspection_id, {
        attendee_ids: [att.id],
      });
      if ((res.data?.sent?.length || 0) > 0) {
        toast.success(`Contract of Sale sent to ${att.name || att.email}.`);
        // Reflect the send immediately so the "Contract sent" badge appears and
        // the button flips to "Resend Contract" without waiting for a refetch.
        const nowIso = new Date().toISOString();
        setInspectionAttendees((prev) =>
          prev.map((a) =>
            a.id === att.id
              ? {
                  ...a,
                  contract_sent_count: (a.contract_sent_count || 0) + 1,
                  contract_last_sent_at: nowIso,
                }
              : a,
          ),
        );
      } else if ((res.data?.skipped?.length || 0) > 0) {
        toast.error("This buyer has no email on file.");
      } else {
        toast.error("Contract could not be sent.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send the contract.");
    } finally {
      setSendingContractAttendeeId(null);
    }
  };

  // Pill shown on attendee cards once a Contract of Sale has been emailed to that
  // person — lets the agent see who's already received one. Green when the buyer
  // has opened it, teal when just sent.
  const renderContractSentBadge = (row) => {
    const count = row?.contract_sent_count || 0;
    if (count < 1) return null;
    const opened = !!row.contract_opened_at;
    const sentStamp = row.contract_last_sent_at
      ? moment(row.contract_last_sent_at).format("D MMM YYYY, h:mm a")
      : null;
    const label = opened
      ? "Contract opened"
      : `Contract sent${count > 1 ? ` ×${count}` : ""}`;
    const title = [
      sentStamp ? `Last sent ${sentStamp}` : "Contract sent",
      count > 1 ? `${count} sends` : null,
      opened ? `Opened ${moment(row.contract_opened_at).format("D MMM YYYY, h:mm a")}` : null,
    ].filter(Boolean).join(" · ");
    return (
      <span
        title={title}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold ${
          opened ? "bg-emerald-100 text-emerald-700" : "bg-[#55C5D0]/15 text-[#3a99a3]"
        }`}
      >
        <CheckCircle2 size={12} /> {label}
      </span>
    );
  };

  // Resolve the CRM contact id for an inspection attendee. Check-ins match-or-
  // create a Contact, so most attendees carry `contact`; fall back to an email
  // lookup for legacy rows that were never linked.
  const resolveAttendeeContactId = async (att) => {
    if (att?.contact) return att.contact;
    if (!att?.email) return null;
    const res = await getContacts({ search: att.email });
    const contacts = res.data?.results || res.data || [];
    return contacts[0]?.id || null;
  };

  // Open the linked CRM contact profile for an attendee (clickable name).
  const handleViewAttendeeContact = async (att) => {
    try {
      const contactId = await resolveAttendeeContactId(att);
      if (contactId) {
        // Carry the origin so the profile's Back arrow returns to this
        // attendees sub-tab, not the generic /contacts list (Monday 13056279356).
        navigate(`/contacts/${contactId}`, {
          state: {
            returnTo: `/collings-properties/${params.id}?tab=enquiries&subtab=${enquiriesSubTab}`,
            returnLabel: property?.address || property?.title || 'Property',
          },
        });
      } else {
        toast.error(
          "No CRM contact found for this attendee. Please search manually in the Contacts section.",
        );
      }
    } catch (err) {
      console.error("Failed to open contact for attendee", err);
      toast.error("Could not open the contact for this attendee.");
    }
  };

  // Email this attendee a buyer-portal sign-up link (welcome / "create my
  // account" email). Reuses the contact invite-to-portal endpoint.
  const handleSendPortalSignupToAttendee = async (att) => {
    if (!att?.email) {
      toast.error("This attendee has no email on file to send a portal sign-up link to.");
      return;
    }
    if (
      !window.confirm(
        `Send a buyer-portal sign-up link to ${att.name || att.email}?`,
      )
    )
      return;
    setInvitingAttendeeId(att.id);
    try {
      const contactId = await resolveAttendeeContactId(att);
      if (!contactId) {
        toast.error(
          "No CRM contact found for this attendee. Add them to Contacts first.",
        );
        return;
      }
      await inviteContactToPortal(contactId);
      toast.success(`Portal sign-up link sent to ${att.name || att.email}.`);
    } catch (err) {
      toast.error(
        err?.response?.data?.error || "Failed to send the portal sign-up link.",
      );
    } finally {
      setInvitingAttendeeId(null);
    }
  };

  // ---- Bulk Communicator (text buyers from the agent's own number) ----
  // Attendees here are flattened across every OFI for this property, so map each
  // selected attendee back to its inspection and render the SMS bodies per
  // inspection (one /bulk-sms-payload call each), then merge the results.
  const groupAttendeesByInspection = (attendeeIds) => {
    const byInspection = {};
    attendeeIds.forEach((id) => {
      const att = inspectionAttendees.find((a) => a.id === id);
      if (!att?.inspection_id) return;
      (byInspection[att.inspection_id] ||= []).push(id);
    });
    return byInspection;
  };

  const loadBulkSmsMessages = async ({ attendeeIds, template }) => {
    const byInspection = groupAttendeesByInspection(attendeeIds);
    // allSettled, not all: one inspection failing (deleted, no access) must not
    // wipe out the whole queue — send to everyone we could render.
    const results = await Promise.allSettled(
      Object.entries(byInspection).map(([inspectionId, ids]) =>
        getBulkSmsPayload(inspectionId, { attendee_ids: ids, template }),
      ),
    );
    const failed = results.filter((r) => r.status === 'rejected');
    if (failed.length && failed.length === results.length) throw failed[0].reason;
    if (failed.length) {
      toast.error(`Could not prepare ${failed.length} open home's messages — sending the rest.`);
    }
    return results
      .filter((r) => r.status === 'fulfilled')
      .reduce(
        (acc, res) => ({
          messages: [...acc.messages, ...(res.value.data?.messages || [])],
          skipped: [...acc.skipped, ...(res.value.data?.skipped || [])],
        }),
        { messages: [], skipped: [] },
      );
  };

  const markBulkSmsHandedOff = async (attendeeIds) => {
    const byInspection = groupAttendeesByInspection(attendeeIds);
    await Promise.all(
      Object.entries(byInspection).map(([inspectionId, ids]) =>
        markSmsHandedOff(inspectionId, ids),
      ),
    );
  };

  // Property-scoped Bulk Communicator for the Enquiries list (Text + Email),
  // mirroring the My-Listings page so this page has the email option too
  // (#12975097413). Attendees stay on the inspection-scoped SMS handlers above.
  const enquiryRecipients = enquiries.map((e) => ({
    id: e.id,
    name: e.name || e.full_name || '',
    phone: e.phone || e.contact || '',
    email: e.email || '',
    contact_id: e.contact_id,
  }));
  const makePropertyBulkHandlers = (recipients) => ({
    loadMessages: async ({ attendeeIds, template }) => {
      const picked = recipients.filter((r) => attendeeIds.includes(r.id));
      const res = await getPropertyBulkSmsPayload(params.id, { recipients: picked, template });
      return { messages: res.data?.messages || [], skipped: res.data?.skipped || [] };
    },
    markHandedOff: async (ids) => {
      const picked = recipients.filter((r) => ids.includes(r.id));
      await markPropertyBulkSmsHandedOff(params.id, picked);
    },
    emailHandlers: {
      loadMessages: async ({ attendeeIds, subject, template }) => {
        const picked = recipients.filter((r) => attendeeIds.includes(r.id));
        const res = await getPropertyBulkEmailPayload(params.id, { recipients: picked, subject, template });
        return { messages: res.data?.messages || [], skipped: res.data?.skipped || [] };
      },
      markHandedOff: async (ids) => {
        const picked = recipients.filter((r) => ids.includes(r.id));
        await markPropertyBulkEmailHandedOff(params.id, picked);
      },
    },
  });

  // The single shared modal is driven by whichever list opened it.
  const bulkConfig =
    bulkContext === 'enquiries'
      ? { recipients: enquiryRecipients, ...makePropertyBulkHandlers(enquiryRecipients) }
      : { recipients: inspectionAttendees, loadMessages: loadBulkSmsMessages, markHandedOff: markBulkSmsHandedOff };

  const openBulkCommunicator = (context) => {
    setBulkContext(context);
    setShowBulkCommunicator(true);
  };

  // Transform raw API response to component format
  const transformPropertyData = (rawData) => {
    if (!rawData) return null;

    // Construct address
    const addressParts = [
      rawData.sub_number,
      rawData.street_number,
      rawData.street,
      rawData.suburb,
      rawData.state,
      rawData.postcode,
    ].filter((part) => part && part !== "0");

    const address = addressParts.join(" ");

    // Extract features
    const features = rawData.features || {};

    // Map images - use top-level images (from serializer: image_urls or images), or extra_info
    const rawImages =
      rawData.images ||
      rawData.extra_info?.image_urls ||
      rawData.extra_info?.images ||
      [];
    const images = Array.isArray(rawImages)
      ? rawImages.map((url) =>
          typeof url === "string"
            ? { file: url }
            : { file: url?.url || url?.file || url },
        )
      : [];

    const agentId = rawData.extra_info?.agent_id ?? rawData.agent?.id;
    return {
      ...rawData,
      address: address || rawData.headline || "No Address",
      price: rawData.price,
      price_display_text:
        rawData.price_display_text ||
        (rawData.price > 0
          ? `$${Number(rawData.price).toLocaleString()}`
          : "Contact Agent"),
      title: rawData.headline,
      beds: features.bedrooms || 0,
      baths: features.bathrooms || 0,
      // Three car-space categories: Garage, Carports, Open parking
      garages: parseInt(features.garages || rawData.parkings || 0),
      car_ports: parseInt(features.carports || rawData.car_ports || 0),
      open_spaces: parseInt(features.openSpaces || rawData.open_spaces || 0),
      parkings: parseInt(features.garages || rawData.parkings || 0),
      parking_spaces: parseInt(features.garages || rawData.parkings || 0),
      open_space: parseInt(features.openSpaces || rawData.open_spaces || 0),
      floor_area: rawData.floor_area || 0,
      land_area: rawData.land_area || 0,
      images: images,
      property_type: rawData.category || rawData.listing_type,
      created_at: rawData.created_at,
      description: rawData.description,
      agent_id: agentId != null ? String(agentId) : undefined,
    };
  };

  // Fetch agents for dropdowns
  useEffect(() => {
    const fetchAgentsList = async () => {
      setAgentsLoading(true);
      try {
        const res = await getAgents({ page_size: 100 });
        const agentsData = res?.data?.results || res?.data || [];
        setAgents(agentsData);
      } catch (error) {
        console.error("Failed to fetch agents:", error);
      } finally {
        setAgentsLoading(false);
      }
    };
    fetchAgentsList();
  }, []);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    getCollingsProperty(params.id)
      .then((res) => {
        if (!isMounted) return;
        const rawData = res?.data || null;

        if (rawData) {
          const transformedData = transformPropertyData(rawData);
          setProperty(transformedData);
          // Fetch documents (works for both CRM and REA/Collings properties)
          getPropertyDocuments(params.id)
            .then((docRes) => {
              if (!isMounted) return;
              const docs = docRes?.data || [];
              setProperty((prev) =>
                prev ? { ...prev, documents: docs } : prev,
              );
            })
            .catch(() => {});
        } else {
          setProperty(null);
        }

        // Build owners list: primary owner + additional owners
        const allOwners = [];
        const primaryOwner = rawData?.owner;
        if (
          primaryOwner &&
          (primaryOwner.name || primaryOwner.contact || primaryOwner.email)
        ) {
          allOwners.push({ ...primaryOwner, isPrimary: true });
        }
        (rawData?.additional_owners || []).forEach((ao) =>
          allOwners.push({ ...ao, isPrimary: false }),
        );
        setOwners(allOwners);

        setError(null);
      })
      .catch((err) => {
        if (!isMounted) return;
        setError(err?.response?.data?.detail || "Failed to load property");
      })
      .finally(() => {
        if (!isMounted) return;
        setIsLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [params.id]);

  // Access control: the Enquiries / Attendees / Offers tab and its buyer data
  // are visible only to the listing's primary agent, secondary agent, or an
  // admin. Every other agent — including the listing's tertiary agent and PA
  // accounts — is blocked. The backend enforces the same rule; this just
  // keeps the tab from rendering for users who would only get a 403.
  const canViewBuyerData = (() => {
    if (!user) return false;
    const isAdmin =
      hasAdminAccess(user) ||
      (Array.isArray(user.secondary_roles) && user.secondary_roles.includes("admin")) ||
      user.is_superuser === true ||
      user.is_staff === true;
    if (isAdmin) return true;
    if (!property) return false;
    const agentId =
      property.agent?.id ??
      property.extra_info?.agent?.id ??
      property.agent_id ??
      property.agent;
    const coAgentId =
      property.co_agent?.id ??
      property.extra_info?.co_agent?.id ??
      property.co_agent_id ??
      property.co_agent;
    return user.id === agentId || user.id === coAgentId;
  })();

  // Editing or deleting a purchaser's details is restricted to admins.
  const isAdmin = (() => {
    if (!user) return false;
    return (
      hasAdminAccess(user) ||
      (Array.isArray(user.secondary_roles) && user.secondary_roles.includes("admin")) ||
      user.is_superuser === true ||
      user.is_staff === true
    );
  })();

  // If a non-permitted user lands on the Enquiries tab, send them back to the
  // Property tab once the listing (and therefore access) is known.
  useEffect(() => {
    if (property && !canViewBuyerData && activeTab === "enquiries") {
      setActiveTab("property");
    }
  }, [property, canViewBuyerData, activeTab]);

  // Fetch property interactions
  useEffect(() => {
    const fetchInteractions = async () => {
      if (!params.id || !canViewBuyerData) return;
      setInteractionsLoading(true);
      try {
        const [enquiriesRes, registrationsRes, inspectionsRes] = await Promise.allSettled([
          getPropertyEnquiries(params.id),
          getPropertyBidderRegistrations(params.id),
          getInspections({ property: params.id }),
        ]);

        if (inspectionsRes.status === "fulfilled") {
          const rawInspections = inspectionsRes.value?.data?.results || inspectionsRes.value?.data || [];
          const seen = new Set();
          const flat = [];
          rawInspections.forEach((insp) => {
            (insp.attendees || []).forEach((att) => {
              const key = `${(att.email || "").toLowerCase().trim()}|${(att.phone || "").trim()}|${(att.name || "").trim().toLowerCase()}`;
              if (seen.has(key)) return;
              seen.add(key);
              flat.push({
                ...att,
                inspection_id: insp.id,
                inspection_date: insp.scheduled_date,
                inspection_status: insp.status,
              });
            });
          });
          setInspectionAttendees(flat);
        }

        if (enquiriesRes.status === "fulfilled") {
          const rawEnquiries = enquiriesRes.value?.data?.results || [];
          const seen = new Set();
          const deduplicated = rawEnquiries.filter((enq) => {
            const email = (enq.email || "").toLowerCase().trim();
            let msg = (enq.message || "").trim();
            if (msg.startsWith("[Buyer Portal") && msg.includes("]\n\n")) {
              msg = msg.split("]\n\n")[1]?.trim() || "";
            }
            if (
              msg.toLowerCase() === "no message" ||
              msg.toLowerCase() === "no message."
            )
              msg = "";

            const key = `${email}|${msg}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          setEnquiries(deduplicated);
        }
        if (registrationsRes.status === "fulfilled") {
          setBidderRegistrations(registrationsRes.value?.data?.results || []);
        }

        const offersRes = await getPropertyOffers(params.id);
        const rawOffers = offersRes.data?.results || [];
        const seenOffers = new Set();
        const deduplicatedOffers = rawOffers.filter((offer) => {
          const email = (offer.buyer_email || offer.email || "")
            .toLowerCase()
            .trim();
          const msg = (offer.message || offer.message_to_agent || "").trim();

          // Extract logical reference
          let trueRef = offer.reference_number;
          const refMatch = msg.match(/OFF-\d{4}-\d{5}/);
          if (refMatch) trueRef = refMatch[0];

          const key = `${email}|${trueRef}`;
          if (seenOffers.has(key)) return false;
          seenOffers.add(key);
          return true;
        });
        setOffers(deduplicatedOffers);

        // Phase 0/1 — load Vendor Portal status badge for this listing
        try {
          const vsRes = await getPropertyVendorStatus(params.id);
          setVendorStatus(vsRes?.data || null);
        } catch (vsErr) {
          // Non-blocking — vendor status is informational only
          console.warn("Failed to load vendor status", vsErr);
        }
      } catch (error) {
        console.error("Failed to fetch property interactions:", error);
      } finally {
        setInteractionsLoading(false);
      }
    };
    fetchInteractions();
    fetchPropertyNotes();
  }, [params.id, canViewBuyerData]);

  // Fetch Buyer Matches when tab is active
  useEffect(() => {
    if (activeTab === "buyer_match" && params.id) {
      const fetchMatches = async () => {
        setBuyerMatchesLoading(true);
        try {
          // Use REA specific matching for Collings Properties
          const res = await getMatchedBuyersForREAProperty(params.id);
          setBuyerMatches(res.data.matched_buyers || []);
        } catch (error) {
          console.error("Failed to fetch buyer matches:", error);
          toast.error("Failed to load buyer matches");
        } finally {
          setBuyerMatchesLoading(false);
        }
      };

      fetchMatches();
    }
  }, [activeTab, params.id]);

  const fetchPropertyNotes = async () => {
    if (!params.id) return;
    setNotesLoading(true);
    try {
      const res = await getPropertyNotes(params.id);
      setPropertyNotes(res.data?.results || res.data || []);
    } catch (err) {
      console.error("Failed to fetch notes", err);
    } finally {
      setNotesLoading(false);
    }
  };

  // The property owner's email/SMS history, shown in the Agent Notes feed
  // (CRM-2026-00102). Keyed off the owner's email via the comms timeline.
  useEffect(() => {
    const paramsForComms = ownerCommsParams(property);
    if (!paramsForComms) {
      setOwnerComms([]);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchCommunicationTimeline(paramsForComms);
        if (!cancelled) setOwnerComms(Array.isArray(data) ? data : data?.results || []);
      } catch (err) {
        if (!cancelled) setOwnerComms([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [property?.owner_email]);

  const handleSaveNote = async () => {
    if (!newNote.trim()) return;

    setIsUpdating(true);
    try {
      await createPropertyNote(params.id, { content: newNote });
      toast.success("Note added successfully");
      setNewNote("");
      fetchPropertyNotes();
    } catch (error) {
      console.error("Error saving note:", error);
      toast.error("Failed to save note. Ensure property is registered in CRM.");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDeleteNote = async (noteId) => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;
    try {
      await deletePropertyNote(noteId);
      toast.success("Note deleted");
      fetchPropertyNotes();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete note");
    }
  };

  const handleUpdateEnquiry = async (formData) => {
    if (!editingEnquiry) return;
    setIsUpdatingEnquiry(true);
    try {
      const res = await updateEnquiry(editingEnquiry.id, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        agent_notes: formData.agent_notes,
        status: formData.status,
        property: formData.propertyId,
      });

      const updatedEnq = res.data?.enquiry || {
        ...editingEnquiry,
        ...formData,
        type_display: editingEnquiry.type_display, // Preserve display fields if not returned
      };

      setEnquiries((prev) =>
        prev.map((e) => (e.id === editingEnquiry.id ? updatedEnq : e)),
      );
      toast.success("Enquiry updated successfully");
      setEditingEnquiry(null);
    } catch (err) {
      toast.error("Failed to update enquiry");
    } finally {
      setIsUpdatingEnquiry(false);
    }
  };

  // Decline an offer from this tab. Same behaviour as Decline Offer in the Buyer
  // Portal Offers pop-up: the offer stays here as the permanent record, marked
  // Declined, and drops out of the Buyer Portal Offers holding list.
  const handleDeclineOffer = async (offer) => {
    if (!offer?.id) return;
    setDecliningOfferId(offer.id);
    try {
      const res = await updateOffer(offer.id, { status: "REJECTED" });
      const data = res?.data || {};
      setOffers((prev) =>
        prev.map((x) => (x.id === offer.id ? { ...x, ...data } : x)),
      );
      // Ignore, not delete: the lead leaves the Buyer Portal Offers holding
      // list, the buyer stays in the CRM and the offer stays on this tab.
      if (offer.lead_id) {
        try {
          await ignoreLead(offer.lead_id, { reason: 'offer_declined' });
          invalidateCache.leads();
        } catch (e) {
          /* holding list is best-effort — the decline itself already saved */
        }
      }
      toast.success("Offer declined. It stays here marked Declined.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to decline offer.");
    } finally {
      setDecliningOfferId(null);
    }
  };

  // "Fill Out Contract" — hand the buyer's details to the eSign contract flow.
  // The offer itself travels in navigation state so its figures (price, deposit,
  // settlement, conditions) prefill the contract (CG, 16 Aug 2026).
  const openContractForOffer = (offer) => {
    const qs = new URLSearchParams({
      newFlow: "contract",
      propertyId: String(params.id),
      buyerName: offer?.buyer_name || "",
      buyerEmail: offer?.buyer_email || "",
    });
    navigate(`/esign/agreements?${qs.toString()}`, { state: { offer: offer || null } });
  };

  const MAX_SOI_SIZE_MB = 2;
  const validateSOIFile = (file) => {
    if (!file) return null;
    const isPdf =
      (file.name || "").toLowerCase().endsWith(".pdf") ||
      file.type === "application/pdf";
    if (!isPdf) {
      toast.error("Only PDF files are accepted for Property Price Statement.");
      return false;
    }
    if (file.size > MAX_SOI_SIZE_MB * 1024 * 1024) {
      toast.error(`File size must be ${MAX_SOI_SIZE_MB}MB or less.`);
      return false;
    }
    return true;
  };
  const handleSOIUpload = async (files) => {
    const fileList = Array.isArray(files) ? files : files ? [files] : [];
    const file = fileList[0];
    if (!file || !validateSOIFile(file)) return;
    setSoiUploading(true);
    try {
      await uploadStatementOfInfo(params.id, [file]);
      const docRes = await getPropertyDocuments(params.id);
      const docs = docRes?.data || [];
      setProperty((p) => (p ? { ...p, documents: docs } : p));
      toast.success("Property Price Statement uploaded successfully.");
      if (soiFileInputRef.current) soiFileInputRef.current.value = "";
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setSoiUploading(false);
    }
  };
  // Every PPS upload is kept (CRM ticket 13177542710): the newest upload is
  // the current statement and the older ones stay listed as previous
  // versions, so there is never a reason to Remove a document first.
  const sortedSoiDocs = (property?.documents || [])
    .filter((d) => d.category === "statement_of_info_docs")
    .slice()
    .sort((a, b) => new Date(b.uploaded_at || 0) - new Date(a.uploaded_at || 0));

  const handleReplaceSOI = () => soiFileInputRef.current?.click();
  const handleRemoveSOI = async () => {
    const soiDoc = sortedSoiDocs[0];
    if (!soiDoc) return;
    if (
      !window.confirm(
        "Remove this Property Price Statement? You can upload a new one anytime.",
      )
    )
      return;
    try {
      await deletePropertyDocument(soiDoc.id);
      const docRes = await getPropertyDocuments(params.id);
      const docs = docRes?.data || [];
      setProperty((p) => (p ? { ...p, documents: docs } : p));
      toast.success("Property Price Statement removed.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to remove document");
    }
  };

  const refreshOwners = (rawData) => {
    const allOwners = [];
    const primaryOwner = rawData?.owner;
    if (
      primaryOwner &&
      (primaryOwner.name || primaryOwner.contact || primaryOwner.email)
    ) {
      allOwners.push({ ...primaryOwner, isPrimary: true });
    }
    (rawData?.additional_owners || []).forEach((ao) =>
      allOwners.push({ ...ao, isPrimary: false }),
    );
    setOwners(allOwners);
  };

  const handleSaveOwner = async (data) => {
    try {
      setIsUpdating(true);
      const hasPrimaryOwner = owners.some((o) => o.isPrimary);

      if (!hasPrimaryOwner) {
        await patchCollingsProperty(params.id, {
          owner_name: data.owner_name,
          owner_preferred_name: data.preferred_name || "",
          contact: data.contact,
          email: data.email,
        });
      } else {
        await addAdditionalOwner(params.id, {
          name: data.owner_name,
          preferred_name: data.preferred_name || "",
          contact: data.contact,
          email: data.email,
        });
      }

      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        setProperty(
          property?.documents
            ? { ...transformedData, documents: property.documents }
            : transformedData,
        );
      }
      refreshOwners(res.data);
      toast.success("Owner added successfully");
      setShowOwnerModal(false);
    } catch (error) {
      console.error("Failed to save owner:", error);
      toast.error("Failed to add owner");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDuplicateProperty = async (form) => {
    if (!property) return;
    try {
      setIsDuplicating(true);

      const postcodeRaw =
        property.postcode ?? property.extra_info?.postcode ?? "";
      const postcodeDigits = String(postcodeRaw).replace(/\D/g, "").slice(0, 4);
      const postcode = postcodeDigits.length === 4 ? postcodeDigits : "0000";

      const existingUrls = form.copy_photos
        ? (property.images || [])
            .map((img) =>
              typeof img === "object" && img?.file ? img.file : img,
            )
            .filter((u) => typeof u === "string" && u.length > 0)
        : [];

      const isRentalClass = ["rental", "holidayRental"].includes(form.property_class);
      const transactionType =
        form.transaction_type === "sale" || form.transaction_type === "lease"
          ? form.transaction_type
          : isRentalClass
            ? "lease"
            : "sale";
      const weeklyRentRaw =
        form.weekly_rent !== undefined && form.weekly_rent !== null
          ? String(form.weekly_rent).replace(/[$,\s]/g, "")
          : "";
      let weeklyRentValue = "";
      if (transactionType === "lease") {
        if (weeklyRentRaw && !Number.isNaN(Number(weeklyRentRaw))) {
          weeklyRentValue = Number(weeklyRentRaw).toFixed(2);
        } else if (property.weekly_rent != null && property.weekly_rent !== "") {
          weeklyRentValue = String(property.weekly_rent);
        }
      }

      const baseExtraInfo = { ...(property.extra_info || {}) };
      baseExtraInfo.property_class = form.property_class;
      baseExtraInfo.transaction_type = transactionType;
      if (transactionType === "lease" && weeklyRentValue) {
        baseExtraInfo.weekly_rent = weeklyRentValue;
      } else {
        delete baseExtraInfo.weekly_rent;
      }
      if (existingUrls.length > 0) {
        baseExtraInfo.images = existingUrls;
      } else {
        delete baseExtraInfo.images;
      }

      const payload = {
        property_type: form.property_class || "residential",
        listing_type: form.property_class || "residential",
        sub_number: form.sub_number || "",
        street_number: form.street_number || "0",
        street: form.street || property.street || "",
        suburb: property.suburb || "",
        state: property.state || "",
        postcode,
        category: property.category || "",
        headline: property.headline || property.title || "Copy of property",
        description: property.description || "",
        price: property.price || 0,
        bedrooms: property.bedrooms || 0,
        bathrooms: property.bathrooms || 0,
        garages: property.garages || 0,
        open_spaces: property.open_spaces || 0,
        toilets: property.toilets || 0,
        agent_id: property.agent_id,
        status: form.status,
        property_class: form.property_class,
        transaction_type: transactionType,
        weekly_rent: weeklyRentValue,
        extra_info: baseExtraInfo,
      };

      const loadingToast = toast.loading("Creating copy...");
      const res = await createREAProperty(payload);
      const newId =
        res?.data?.id || res?.data?.property?.id || res?.data?.pk || null;

      if (form.copy_owners && newId) {
        const ownersToCopy = (owners || []).filter(
          (o) => o && (o.name || o.email || o.contact),
        );
        for (const o of ownersToCopy) {
          try {
            if (o.isPrimary) {
              await patchCollingsProperty(newId, {
                owner_name: o.name || "",
                owner_preferred_name: o.preferred_name || "",
                contact: o.contact || "",
                email: o.email || "",
              });
            } else {
              await addAdditionalOwner(newId, {
                name: o.name || "",
                preferred_name: o.preferred_name || "",
                contact: o.contact || "",
                email: o.email || "",
              });
            }
          } catch (e) {
            console.warn("Failed to copy owner:", e);
          }
        }
      }

      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      toast.dismiss(loadingToast);
      toast.success("Property duplicated");
      setShowDuplicateModal(false);
      if (newId) {
        navigate(`/collings-properties/${newId}`);
      }
    } catch (err) {
      console.error("Failed to duplicate property:", err);
      const detail =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to duplicate property";
      toast.error(detail);
    } finally {
      setIsDuplicating(false);
    }
  };

  const handleDeleteOwner = async (owner) => {
    if (!window.confirm(`Remove ${owner.name} from this property?`)) return;
    try {
      setIsUpdating(true);
      if (owner.isPrimary) {
        await patchCollingsProperty(params.id, {
          owner_name: "",
          contact: "",
          email: "",
        });
      } else {
        await deleteAdditionalOwner(params.id, owner.id);
      }
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        setProperty(
          property?.documents
            ? { ...transformedData, documents: property.documents }
            : transformedData,
        );
      }
      refreshOwners(res.data);
      toast.success("Owner removed");
    } catch (error) {
      console.error("Failed to remove owner:", error);
      toast.error("Failed to remove owner");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleSavePurchaser = async (data) => {
    const isEditing = Boolean(editingPurchaser);
    try {
      setIsUpdating(true);
      const payload = {
        purchaser_name: data.purchaser_name,
        purchaser_contact: data.purchaser_contact,
        purchaser_email: data.purchaser_email,
      };
      await patchCollingsProperty(params.id, payload);
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      if (res.data?.purchaser) {
        setPurchasers([res.data.purchaser]);
      }
      toast.success(isEditing ? "Purchaser updated successfully" : "Purchaser added successfully");
      setShowPurchaserModal(false);
      setEditingPurchaser(null);
    } catch (error) {
      console.error("Failed to save purchaser:", error);
      toast.error(isEditing ? "Failed to update purchaser" : "Failed to add purchaser");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleEditPurchaser = (purchaser) => {
    setEditingPurchaser({
      purchaser_name: purchaser.name || "",
      purchaser_email: purchaser.email || "",
      purchaser_contact: purchaser.contact || purchaser.phone || "",
    });
    setShowPurchaserModal(true);
  };

  const handleDeletePurchaser = async () => {
    if (!window.confirm("Delete this purchaser's details? This cannot be undone.")) return;
    try {
      setIsUpdating(true);
      await patchCollingsProperty(params.id, {
        purchaser_name: "",
        purchaser_contact: "",
        purchaser_email: "",
      });
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      setPurchasers(res.data?.purchaser ? [res.data.purchaser] : []);
      toast.success("Purchaser deleted");
    } catch (error) {
      console.error("Failed to delete purchaser:", error);
      toast.error("Failed to delete purchaser");
    } finally {
      setIsUpdating(false);
    }
  };

  // Gallery Management Logic
  const handleReplaceImage = (img) => {
    targetImageForReplacement.current = img;
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !targetImageForReplacement.current) return;
    {
      const { rejected } = splitSupportedUploads([file]);
      if (rejected.length) {
        toast.error(rejectedUploadsMessage(rejected));
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
    }

    const imageToDelete =
      typeof targetImageForReplacement.current === "object"
        ? targetImageForReplacement.current.file
        : targetImageForReplacement.current;

    const formData = new FormData();
    formData.append("images", file);
    formData.append("delete_images", JSON.stringify([imageToDelete]));

    try {
      setUpdatingGallery(true);
      const loadingToast = toast.loading("Replacing image...");
      await updateCollingsProperty(params.id, formData);
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      toast.dismiss(loadingToast);
      toast.success("Image replaced successfully");
    } catch (err) {
      toast.error("Failed to replace image");
    } finally {
      setUpdatingGallery(false);
      targetImageForReplacement.current = null;
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleDeleteImage = async (img) => {
    const imageToDelete = typeof img === "object" ? img.file : img;
    const keyOf = (i) => (typeof i === "object" && i?.file ? i.file : i);
    const targetKey = keyOf(img);

    const previousImages = property?.images || [];
    const nextImages = previousImages.filter((i) => keyOf(i) !== targetKey);

    setProperty((prev) => (prev ? { ...prev, images: nextImages } : prev));

    const formData = new FormData();
    formData.append("delete_images", JSON.stringify([imageToDelete]));

    try {
      await updateCollingsProperty(params.id, formData);
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      toast.success("Image removed");
    } catch (err) {
      setProperty((prev) => (prev ? { ...prev, images: previousImages } : prev));
      toast.error("Failed to remove image");
    }
  };

  // Upload portal-safe files picked in the Manage Gallery dialog (it vets the
  // pick itself before calling this).
  const uploadImages = async (files) => {
    if (!files || files.length === 0) return;
    if (!property?.agent_id) {
      toast.error(
        "Property agent is required to update images. Please set an agent first.",
      );
      return;
    }

    // Build payload so backend receives existing image URLs (in extra_info) and new files (images)
    const existingUrls = (property.images || [])
      .map((img) => (typeof img === "object" && img?.file ? img.file : img))
      .filter(Boolean);

    const postcodeRaw =
      property.postcode ?? property.extra_info?.postcode ?? "";
    const postcodeDigits = String(postcodeRaw).replace(/\D/g, "").slice(0, 4);
    const postcode = postcodeDigits.length === 4 ? postcodeDigits : "0000";
    const payload = {
      property_type:
        property.listing_type || property.property_type || "residential",
      listing_type:
        property.listing_type || property.property_type || "residential",
      sub_number: property.sub_number ?? "",
      street_number: property.street_number ?? "0",
      street: property.street ?? "",
      suburb: property.suburb ?? "",
      state: property.state ?? "",
      postcode,
      category: property.category ?? "",
      headline: property.headline ?? property.title ?? "",
      description: property.description ?? "",
      price: property.price ?? 0,
      agent_id: property.agent_id,
      extra_info: { ...(property.extra_info || {}), images: existingUrls },
      images: files,
    };

    try {
      setUpdatingGallery(true);
      const loadingToast = toast.loading("Uploading images...");
      const res = await updateCollingsProperty(params.id, payload);
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      const transformedData = transformPropertyData(res?.data);
      if (transformedData) {
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      toast.dismiss(loadingToast);
      toast.success("Images uploaded successfully");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to upload images");
    } finally {
      setUpdatingGallery(false);
    }
  };

  // Floorplan tab of the Manage Gallery dialog. Separate from uploadImages -
  // floorplan status is tagged directly via a dedicated field rather than a
  // per-photo checkbox, since that checkbox existed on the My Listings edit
  // form already and still didn't reliably persist for agents editing from
  // this Collings Properties screen (2026-08-14, 8/118 Miller Street).
  const handleAddFloorplan = async (e) => {
    const { ok: files, rejected } = splitSupportedUploads(Array.from(e.target.files));
    if (rejected.length) toast.error(rejectedUploadsMessage(rejected));
    if (files.length === 0) {
      if (floorplanInputRef.current) floorplanInputRef.current.value = "";
      return;
    }
    const existingCount = (property?.floorplan_images || []).length;
    if (existingCount + files.length > 2) {
      toast.error(
        `REA allows at most 2 floorplan images (${existingCount} already tagged).`,
      );
      if (floorplanInputRef.current) floorplanInputRef.current.value = "";
      return;
    }
    try {
      setUploadingFloorplan(true);
      const res = await uploadCollingsPropertyFloorplan(params.id, files);
      setProperty((prev) =>
        prev ? { ...prev, floorplan_images: res?.data?.floorplan_images || [] } : prev,
      );
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      toast.success("Floorplan uploaded successfully");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to upload floorplan");
    } finally {
      setUploadingFloorplan(false);
      if (floorplanInputRef.current) floorplanInputRef.current.value = "";
    }
  };

  const handleDeleteFloorplan = async (floorplanId) => {
    const previous = property?.floorplan_images || [];
    setProperty((prev) =>
      prev
        ? {
            ...prev,
            floorplan_images: previous.filter((f) => f.id !== floorplanId),
          }
        : prev,
    );
    try {
      const res = await deleteCollingsPropertyFloorplan(params.id, [floorplanId]);
      setProperty((prev) =>
        prev ? { ...prev, floorplan_images: res?.data?.floorplan_images || [] } : prev,
      );
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      toast.success("Floorplan removed");
    } catch (err) {
      setProperty((prev) => (prev ? { ...prev, floorplan_images: previous } : prev));
      toast.error("Failed to remove floorplan");
    }
  };

  // Persist a new photo order from the Manage Gallery dialog (it autosaves;
  // see ManageGalleryDialog). The REA endpoint only rewrites extra_info.images,
  // so mirror the order locally rather than refetching the whole listing.
  const saveImageOrder = async (reorderedUrls) => {
    if (!property?.agent_id) {
      throw new Error("Property agent is required to update images.");
    }
    await reorderCollingsPropertyImages(params.id, reorderedUrls);
    setProperty((prev) =>
      prev ? { ...prev, images: applyImageOrder(prev.images, reorderedUrls) } : prev
    );
  };

  const handleEditInfo = () => {
    // Map property_type to display value (category might be "Apartment", "House", etc.)
    // We need to map listing_type to display values
    const getDisplayPropertyType = () => {
      const listingType = property.listing_type?.toLowerCase();
      if (
        listingType === "residential" ||
        listingType === "commercial" ||
        listingType === "land"
      ) {
        return listingType.charAt(0).toUpperCase() + listingType.slice(1); // Capitalize first letter
      }
      // Default to Residential if we can't determine
      return "Residential";
    };

    setEditForm({
      price: property.price || "",
      price_display_text:
        property.price_display_text || `Offers above ${property.price}`,
      weekly_rent:
        property.weekly_rent != null && property.weekly_rent !== ""
          ? String(property.weekly_rent)
          : property.extra_info?.weekly_rent != null
            ? String(property.extra_info.weekly_rent)
            : "",
      bond:
        property.bond != null && property.bond !== ""
          ? String(property.bond)
          : property.extra_info?.bond != null
            ? String(property.extra_info.bond)
            : "",
      property_type: getDisplayPropertyType(),
      beds: property.beds ?? 0,
      baths: property.baths ?? 0,
      garages: property.garages ?? property.parkings ?? property.parking_spaces ?? 0,
      car_ports: property.car_ports ?? 0,
      open_spaces: property.open_spaces ?? property.open_space ?? 0,
      floor_area: property.floor_area || 0,
      land_area: property.land_area || 0,
    });
    setIsEditingInfo(true);
  };

  const handleInputChange = (field, value) => {
    setEditForm((prev) => {
      const next = { ...prev, [field]: value };
      if (field === "bond") {
        // Keep bond numeric for the backend's DecimalField, even if typed as "$2,500".
        next.bond = String(value).replace(/[^\d]/g, "");
      } else if (field === "weekly_rent" && isLease) {
        // Rental bond auto-tracks the weekly rent (Victorian calendar-month rule).
        // Agents can still type their own bond afterwards to override it.
        next.bond = calculateBond(value, prev.property_type).replace(/[^\d]/g, "");
      }
      return next;
    });
  };

  const handleSaveInfo = async () => {
    try {
      setIsUpdating(true);

      // Map property_type from display values to backend values
      // Valid backend choices: residential, commercial, business, land, rural, rental, holidayRental
      const propertyTypeMap = {
        Residential: "residential",
        Commercial: "commercial",
        Land: "land",
      };

      // Get the mapped property type, or use listing_type from property, or default to residential
      let mappedPropertyType = propertyTypeMap[editForm.property_type];
      if (!mappedPropertyType) {
        // If not in map, try to get from property's listing_type
        const listingType = property.listing_type?.toLowerCase();
        if (
          listingType &&
          [
            "residential",
            "commercial",
            "business",
            "land",
            "rural",
            "rental",
            "holidayrental",
          ].includes(listingType)
        ) {
          mappedPropertyType =
            listingType === "holidayrental" ? "holidayRental" : listingType;
        } else {
          // Default to residential if we can't determine
          mappedPropertyType = "residential";
        }
      }

      // Prepare update payload with all required fields from current property
      // Since transformPropertyData spreads rawData, all original fields are preserved
      // Ensure all required fields have values (not empty strings that would be falsy)
      const updatePayload = {
        // Required fields - ensure they have values
        street: property.street || property.street_name || "",
        suburb: property.suburb || "",
        state: property.state || "",
        postcode: property.postcode || "",
        // Preserve category (e.g., "Apartment", "House") - this is different from property_type
        // Category is the specific type, property_type is the general classification
        category: property.category || property.property_type || "",
        headline: property.headline ?? property.title ?? "",
        description: property.description ?? "",
        // property_type should be the general type (residential, commercial, land)
        // The API function maps this to listing_type in the backend
        property_type: mappedPropertyType,
        // Also set listing_type explicitly to match the model field
        listing_type: mappedPropertyType,

        // Updated fields from editForm
        price: editForm.price || property.price || 0,
        price_display_text:
          editForm.price_display_text || property.price_display_text,
        // When user clears weekly_rent, send null so backend clears it (do not fall back to old value)
        weekly_rent:
          editForm.weekly_rent !== "" && editForm.weekly_rent != null
            ? editForm.weekly_rent
            : null,
        // Bond auto-tracks weekly rent; same clear-to-null handling.
        bond:
          editForm.bond !== "" && editForm.bond != null ? editForm.bond : null,
        floor_area: editForm.floor_area || property.floor_area || 0,
        land_area: editForm.land_area || property.land_area || 0,

        // Parking fields - map to backend format
        // Backend stores garages, openSpaces, and carports in features JSON object
        // Send both top-level (for serializer mapping) and in features object
        parking_spaces: editForm.garages ?? property.garages ?? property.parkings ?? 0,
        garages: editForm.garages ?? property.garages ?? property.parkings ?? 0,
        open_spaces: editForm.open_spaces ?? property.open_spaces ?? property.open_space ?? 0,
        // Bedrooms / bathrooms
        bedrooms: editForm.beds ?? property.beds ?? 0,
        bathrooms: editForm.baths ?? property.baths ?? 0,
        beds: editForm.beds ?? property.beds ?? 0,
        baths: editForm.baths ?? property.baths ?? 0,
        // Features object - carports and openSpaces must be in features JSON
        // Spread existing features first, then override with updated values
        features: {
          ...(typeof property.features === 'object' && property.features !== null && !Array.isArray(property.features)
            ? property.features
            : {}),
          bedrooms: editForm.beds ?? property.beds ?? 0,
          bathrooms: editForm.baths ?? property.baths ?? 0,
          garages: editForm.garages ?? property.garages ?? property.parkings ?? 0,
          carports: editForm.car_ports ?? property.car_ports ?? 0,
          openSpaces: editForm.open_spaces ?? property.open_spaces ?? property.open_space ?? 0,
        },

        // Preserve existing address fields
        sub_number: property.sub_number || "",
        street_number: property.street_number || "0",
        agent_id: property.agent_id ?? property.agent?.id,
      };

      // Ensure required string fields are not empty (backend validation)
      if (
        !updatePayload.street ||
        !updatePayload.suburb ||
        !updatePayload.state ||
        !updatePayload.postcode ||
        !updatePayload.category ||
        !updatePayload.headline ||
        !updatePayload.description
      ) {
        console.warn("Missing required fields:", {
          street: updatePayload.street,
          suburb: updatePayload.suburb,
          state: updatePayload.state,
          postcode: updatePayload.postcode,
          category: updatePayload.category,
          headline: updatePayload.headline,
          description: updatePayload.description,
        });
      }

      try {
        await updateCollingsProperty(params.id, updatePayload);
      } catch (err) {
        // A live listing's price change needs a reason (compliance price history).
        if (!isPriceReasonRequired(err)) throw err;
        const extra = await requestPriceReason();
        if (!extra) return;
        await updateCollingsProperty(params.id, { ...updatePayload, ...extra });
      }
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        // Preserve documents if they exist in current property state
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      setIsEditingInfo(false);
      toast.success("Information updated");
    } catch (err) {
      console.error("Update error:", err?.response?.data);
      const errorMsg =
        err?.response?.data?.errors ||
        err?.response?.data?.detail ||
        "Update failed";
      toast.error(typeof errorMsg === "string" ? errorMsg : "Update failed");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleEditDescription = () => {
    setDescriptionEdit(property.description || "");
    setIsEditingDescription(true);
  };

  const handleSaveDescription = async () => {
    try {
      setIsUpdating(true);
      await updateCollingsProperty(params.id, { description: descriptionEdit });
      invalidateCache.collingsProperties();
      invalidateCache.publicProperties();
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      setIsEditingDescription(false);
      toast.success("Description updated");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Update failed");
    } finally {
      setIsUpdating(false);
    }
  };

  const formatDescription = (description) => {
    if (!description) return ["No description available."];
    let paragraphs = description.split(/\n\n+/);
    if (paragraphs.length === 1) {
      paragraphs = description.split(/\n/);
    }
    if (paragraphs.length === 1) {
      paragraphs = description.split(/\.\s+(?=[A-Z])/);
      paragraphs = paragraphs.map(
        (p) => p.trim() + (p.endsWith(".") ? "" : "."),
      );
    }
    return paragraphs.map((p) => p.trim()).filter((p) => p.length > 0);
  };

  const refetchCollingsProperty = async () => {
    const res = await getCollingsProperty(params.id);
    const transformedData = transformPropertyData(res.data);
    if (transformedData) {
      const updatedProperty = property?.documents
        ? { ...transformedData, documents: property.documents }
        : transformedData;
      setProperty(updatedProperty);
    }
  };

  const handlePropertyWithdraw = async (reason, reasonNote) => {
    if (property?.listing_id) {
      const reaResponse = await withdrawREAPropertyFromREA(params.id, reason, reasonNote);
      toast.success(
        reaResponse.data?.message || "Property withdrawn from REA successfully",
      );
    } else {
      await patchCollingsProperty(params.id, {
        is_withdrawn: true,
        reason,
        reason_note: reasonNote,
      });
      toast.success("Property withdrawn successfully");
    }
    await refetchCollingsProperty();
  };

  const handlePropertyRelist = async () => {
    await patchCollingsProperty(params.id, { is_withdrawn: false });
    toast.success("Property relisted successfully");
    await refetchCollingsProperty();
  };

  // The green "Listed" button: mark an appraisal as Listed (won, awaiting portal
  // upload). Christian Gravias, Monday 13225851756.
  const statusNameLower = (property?.status?.name || property?.status || "").toString().trim().toLowerCase();
  const isAppraisalStatus = statusNameLower === "appraisal";
  const isListedStatus = statusNameLower === "listed";

  const handleMarkListed = async () => {
    setIsMarkingListed(true);
    try {
      await markPropertyListed(params.id);
      await refetchCollingsProperty();
      toast.success("Marked as Listed — now in My Listings, awaiting portal upload.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not mark this as Listed.");
    } finally {
      setIsMarkingListed(false);
    }
  };

  const handleToggleSold = async (soldDetails = null) => {
    setIsMarkingSold(true);
    // Check both is_sold field and status field
    const isCurrentlySold =
      property?.is_sold ||
      property?.status === "Sold" ||
      property?.status?.name === "Sold";
    try {
      const updateData = { is_sold: !isCurrentlySold };
      // When marking as sold, include the captured sale price + portal suppression flag,
      // the settlement date, and the agent commission split (co-agent + primary split %).
      // These flow through to the Commissions leaderboard.
      if (!isCurrentlySold && soldDetails && typeof soldDetails.soldPrice === "number") {
        Object.assign(updateData, buildSaleDetailsPatch(soldDetails, { withPortalFlag: true }));
      }
      await patchCollingsProperty(params.id, updateData);
      toast.success(
        isCurrentlySold
          ? "Property marked as unsold successfully"
          : "Property marked as sold successfully",
      );
      // Invalidate listing caches so Collings Properties page reflects new sold status immediately
      invalidateCache.collingsProperties();
      // Refresh property data
      const res = await getCollingsProperty(params.id);
      const transformedData = transformPropertyData(res.data);
      if (transformedData) {
        const updatedProperty = property?.documents
          ? { ...transformedData, documents: property.documents }
          : transformedData;
        setProperty(updatedProperty);
      }
      setShowSoldModal(false);
    } catch (err) {
      toast.error("Failed to update sold status");
      console.error("Sold toggle error:", err);
    } finally {
      setIsMarkingSold(false);
    }
  };

  // Re-read the property after a save, keeping the documents already loaded.
  const refreshProperty = async () => {
    const res = await getCollingsProperty(params.id);
    const transformedData = transformPropertyData(res.data);
    if (transformedData) {
      setProperty((prev) =>
        prev?.documents
          ? { ...transformedData, documents: prev.documents }
          : transformedData,
      );
    }
  };

  // Correct the details of a sale that is already recorded (wrong sold date,
  // price, split) without marking the property unsold first. The backend
  // treats is_sold=true on a sold property as a correction and updates the
  // linked CRM record and commission in place. Portals are not re-published
  // here; the toast offers that step.
  const handleSaveSaleDetails = async (soldDetails) => {
    setIsSavingSale(true);
    try {
      await patchCollingsProperty(
        params.id,
        buildSaleDetailsPatch(soldDetails, { withPortalFlag: true }),
      );
      invalidateCache.collingsProperties();
      await refreshProperty();
      setShowEditSaleModal(false);
      promptPublishSold(() => setShowPublishSoldModal(true));
    } catch (err) {
      toast.error("Failed to save sale details");
      console.error("Save sale details error:", err);
    } finally {
      setIsSavingSale(false);
    }
  };

  const handlePortalAttributionToggle = async (nextValue) => {
    await patchCollingsProperty(params.id, {
      sold_through_collings_portal: nextValue,
    });
    const res = await getCollingsProperty(params.id);
    const transformedData = transformPropertyData(res.data);
    if (transformedData) {
      setProperty((prev) =>
        prev?.documents
          ? { ...transformedData, documents: prev.documents }
          : transformedData,
      );
    }
    toast.success(
      nextValue
        ? "Marked as sold through the Collings portal"
        : "Removed Collings portal attribution",
    );
  };

  const isPropertySold =
    property?.is_sold ||
    property?.status === "Sold" ||
    property?.status?.name === "Sold";

  // What the Mark-as-Sold / Edit Sale Details dialog starts from.
  const saleModalProps = {
    address: property?.address,
    initialSoldPrice: property?.sold_price,
    initialSuppress: property?.suppress_sold_price,
    initialSoldThroughPortal: property?.sold_through_collings_portal,
    agents,
    primaryAgentId: property?.agent?.id ?? property?.agent_id ?? "",
    primaryAgentName: property?.agent?.name ?? "",
    listingCoAgent: property?.co_agent ?? property?.extra_info?.co_agent ?? null,
    initialSoldDate: property?.sold_date ?? property?.extra_info?.sold_date ?? "",
    defaultSoldDate: defaultSoldDate(property),
    contractDate: contractDateOf(property),
    reaSoldLocked: Boolean(property?.rea_sold_locked),
    initialSettlementDate:
      property?.settlement_date ?? property?.extra_info?.settlement_date ?? "",
    // Prefer whoever the recorded commission actually splits with, so
    // reopening the modal shows the real split, not the marketing co-agent.
    initialCoAgentId:
      property?.commission_co_agent?.id ??
      property?.co_agent?.id ??
      property?.extra_info?.co_agent?.id ??
      property?.co_agent ??
      "",
    initialSplitPercentage:
      property?.commission_split_percentage ??
      property?.extra_info?.commission_split_percentage ??
      "",
    initialNoCommissionCredit: property?.no_commission_credit ?? false,
  };

  const handleDeleteProperty = async () => {
    setIsDeleting(true);
    try {
      await deleteCollingsProperty(params.id);
      toast.success('Property moved to trash. You have 90 days to restore it.');
      invalidateCache.collingsProperties();
      navigate('/collings-properties');
    } catch (err) {
      toast.error('Failed to delete property');
      console.error('Delete property error:', err);
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center min-h-screen bg-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#55C5D0] mx-auto mb-4"></div>
          <p className="text-lg text-[#374151] font-medium">
            Loading property details...
          </p>
        </div>
      </div>
    );
  }

  if (error || !property) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <div className="text-center p-8 bg-white rounded-xl shadow-sm border border-gray-100 max-w-md">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-red-400" />
          </div>
          <h3 className="text-xl font-semibold text-[#374151] mb-2">
            {error || "Property Not Found"}
          </h3>
          <p className="text-[#374151] opacity-70 mb-6 font-medium">
            The property you're looking for doesn't exist or has been removed
            from our database.
          </p>
          <Link to="/properties">
            <Button className="w-full bg-[#55C5D0] hover:bg-[#4AADB7] text-white py-6 rounded-xl font-bold shadow-lg shadow-cyan-100 transition-all">
              Return to Listings
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  const renderPropertyTab = () => (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-2 space-y-6">
          <div className="bg-white rounded-xl border border-gray-200 p-3 sm:p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4 sm:mb-8">
              <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">
                Property Images
              </h3>
              <button
                onClick={() => setIsGalleryOpen(true)}
                className="px-5 py-2 bg-[#ECECEC] hover:bg-gray-200 text-[#374151] rounded-md text-[11px] font-bold transition-all"
              >
                Edit Gallery
              </button>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4">
              {property?.images && property.images.length > 0 ? (
                property.images.map((img, idx) => (
                  <div
                    key={idx}
                    onClick={() => setLightboxIndex(idx)}
                    className="group relative aspect-square bg-gray-100 rounded-lg sm:rounded-xl overflow-hidden cursor-pointer border-2 border-transparent hover:border-[#55C5D0] transition-all duration-300 isolate z-0"
                  >
                    <LazyImage
                      src={img?.file || img}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    {/* Hover Overlay - contained so floating UI doesn't overlap */}
                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-10">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReplaceImage(img);
                        }}
                        className="w-10 h-10 bg-white/90 rounded-full flex items-center justify-center shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 hover:bg-white hover:text-[#55C5D0]"
                      >
                        <Edit className="w-5 h-5 text-[#55C5D0]" />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-3 aspect-[3/1] flex flex-col items-center justify-center bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                  <Eye className="w-12 h-12 text-[#374151] opacity-20 mb-2" />
                  <p className="text-[#374151] opacity-50 font-medium">
                    No images available for this property
                  </p>
                </div>
              )}
            </div>

            {/* Full-size photo viewer: click a tile to open, arrows / swipe
                buttons to move, Esc / X / backdrop click to close. */}
            {lightboxIndex !== null && property?.images?.[lightboxIndex] != null && (
              <div
                className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80"
                onClick={() => setLightboxIndex(null)}
              >
                <button
                  type="button"
                  aria-label="Close photo viewer"
                  className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
                  onClick={() => setLightboxIndex(null)}
                >
                  <X className="w-6 h-6" />
                </button>
                <div className="absolute top-4 left-4 text-white/90 text-sm font-semibold bg-black/50 rounded-full px-3 py-1.5">
                  {lightboxIndex + 1} / {property.images.length}
                </div>
                {property.images.length > 1 && (
                  <>
                    <button
                      type="button"
                      aria-label="Previous photo"
                      className="absolute left-3 sm:left-6 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLightboxIndex(
                          (lightboxIndex - 1 + property.images.length) % property.images.length
                        );
                      }}
                    >
                      <ChevronLeft className="w-7 h-7" />
                    </button>
                    <button
                      type="button"
                      aria-label="Next photo"
                      className="absolute right-3 sm:right-6 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLightboxIndex((lightboxIndex + 1) % property.images.length);
                      }}
                    >
                      <ChevronRight className="w-7 h-7" />
                    </button>
                  </>
                )}
                <div
                  className="max-w-[90vw] max-h-[90vh] flex items-center justify-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    src={
                      property.images[lightboxIndex]?.file ||
                      property.images[lightboxIndex]
                    }
                    alt={`Property photo ${lightboxIndex + 1}`}
                    className="max-w-full max-h-[85vh] rounded-lg shadow-2xl object-contain"
                  />
                </div>
              </div>
            )}

            {/* Hidden File Input for Single Replacement */}
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              accept={SUPPORTED_UPLOAD_ACCEPT}
              onChange={handleFileChange}
            />

            {/* Gallery Management Dialog (shared with the CRM and public property
                pages - see ManageGalleryDialog). The Floorplan tab is this
                page's own: REA floorplans are tagged via a dedicated upload
                rather than a per-photo flag here. */}
            <ManageGalleryDialog
              open={isGalleryOpen}
              onClose={() => setIsGalleryOpen(false)}
              images={property?.images || []}
              busy={updatingGallery}
              onReorder={saveImageOrder}
              onAddFiles={uploadImages}
              onDelete={handleDeleteImage}
              extraTab={{
                label: "Floorplan",
                description: "Upload up to 2 floorplan images. These appear under REA's separate Floorplan tab, not the regular Images gallery.",
                content: (
                  <>
                    <div className="flex items-center justify-between mb-3">
                      <p className="text-[11px] text-[#374151] opacity-70 font-medium">
                        {(property?.floorplan_images || []).length}/2 floorplan images tagged.
                      </p>
                      {(property?.floorplan_images || []).length < 2 && (
                        <div
                          onClick={() => floorplanInputRef.current?.click()}
                          className="flex items-center gap-2 px-3 py-2 border border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 hover:border-[#55C5D0]/60 transition-all group"
                        >
                          <UploadCloud className="w-4 h-4 text-gray-400 group-hover:text-[#55C5D0]" />
                          <span className="text-[11px] font-bold text-gray-500 group-hover:text-[#55C5D0]">
                            {uploadingFloorplan ? "Uploading…" : "Add Floorplan"}
                          </span>
                          <input
                            type="file"
                            ref={floorplanInputRef}
                            className="hidden"
                            multiple
                            accept={SUPPORTED_UPLOAD_ACCEPT}
                            disabled={uploadingFloorplan}
                            onChange={handleAddFloorplan}
                          />
                        </div>
                      )}
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                      {(property?.floorplan_images || []).map((fp) => (
                        <div
                          key={fp.id}
                          className="relative group aspect-square bg-gray-100 rounded-xl overflow-hidden border-2 border-transparent hover:border-gray-300"
                        >
                          <img
                            src={fp.url}
                            alt="Floorplan"
                            loading="lazy"
                            className="w-full h-full object-contain pointer-events-none select-none bg-white"
                          />
                          <button
                            type="button"
                            onClick={() => handleDeleteFloorplan(fp.id)}
                            className="absolute top-2 right-2 p-1.5 bg-white/90 text-red-500 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-50 z-10"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>

                    {(!property?.floorplan_images || property.floorplan_images.length === 0) && (
                      <div className="flex flex-col items-center justify-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                        <UploadCloud className="w-10 h-10 text-gray-300 mb-2" />
                        <p className="text-[#374151] opacity-50 text-sm font-medium">
                          No floorplan yet. Click "Add Floorplan" to upload.
                        </p>
                      </div>
                    )}
                  </>
                ),
              }}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-6">
              {(() => {
                const statusName =
                  property?.status?.name ||
                  property?.status ||
                  property?.extra_info?.status ||
                  "";
                const isOnMarket =
                  statusName === "On Market Listing" ||
                  (typeof statusName === "string" &&
                    statusName.toLowerCase().includes("on market"));
                const isAppraisal =
                  statusName === "Appraisal" ||
                  (typeof statusName === "string" &&
                    statusName.toLowerCase().includes("appraisal"));
                const isOffMarket =
                  statusName === "Off Market Listing" ||
                  (typeof statusName === "string" &&
                    statusName.toLowerCase().includes("off market"));
                if (isAppraisal) {
                  // Agent dropdown for the appraisal — adding an agent here lets
                  // them see the appraisal in their own pipeline. Third agent is
                  // access-only (Monday 13065093914). Writes go through
                  // updateCollingsProperty, which mirrors the agent onto the
                  // linked Property FK the pipeline query reads.
                  const appraisalAgentSelect = (label, currentId, apiKey, onSet) => (
                    <div>
                      <label className="block text-[11px] text-[#374151] mb-2 font-medium">{label}</label>
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={currentId || ""}
                        disabled={agentsLoading}
                        onChange={async (e) => {
                          const val = e.target.value;
                          try {
                            await updateCollingsProperty(property.id, { [apiKey]: val || "null" });
                            invalidateCache.collingsProperties();
                            const picked = agents.find((a) => String(a.id) === String(val)) || null;
                            onSet(picked, val);
                            toast.success(`${label} updated`);
                          } catch (err) {
                            toast.error(`Failed to update ${label.toLowerCase()}`);
                          }
                        }}
                      >
                        <option value="">None</option>
                        {agents.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name || `${a.first_name || ""} ${a.last_name || ""}`.trim() || `Agent ${a.id}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                  return (
                    <>
                      <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                        <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#111827] mb-4">
                          Appraisal – Pipeline
                        </h3>
                        <p className="text-[11px] text-[#374151] opacity-70 mb-4">
                          No visibility options. Sorted in your pipeline by type
                          and temperature.
                        </p>
                        <div className="space-y-2 text-[11px] text-[#374151]">
                          <p>
                            <span className="font-medium">Type:</span>{" "}
                            {property?.appraisal_market_type === "on_market"
                              ? "On-Market"
                              : property?.appraisal_market_type === "off_market"
                                ? "Off-Market"
                                : "—"}
                          </p>
                          <p>
                            <span className="font-medium">Temperature:</span>{" "}
                            {property?.appraisal_temperature
                              ? String(property.appraisal_temperature)
                                  .charAt(0)
                                  .toUpperCase() +
                                String(property.appraisal_temperature).slice(1)
                              : "—"}
                          </p>
                        </div>
                      </div>
                      <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm mt-4">
                        <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-2">
                          Agents
                        </h3>
                        <p className="text-[11px] text-[#374151] opacity-70 mb-6 font-medium leading-relaxed">
                          Add agents so they can see this appraisal in their own pipeline. The third agent has access only.
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {appraisalAgentSelect("Primary Agent", property?.agent?.id, "agent_id",
                            (picked, val) => setProperty((p) => ({ ...p, agent: picked, agent_id: val })))}
                          {appraisalAgentSelect("Secondary Agent", property?.co_agent?.id ?? property?.extra_info?.co_agent?.id, "co_agent_id",
                            (picked, val) => setProperty((p) => ({ ...p, co_agent: picked, co_agent_id: val })))}
                          {appraisalAgentSelect("Third Agent (access only)", property?.tertiary_agent?.id ?? property?.extra_info?.tertiary_agent?.id, "tertiary_agent_id",
                            (picked, val) => setProperty((p) => ({ ...p, tertiary_agent: picked, tertiary_agent_id: val })))}
                        </div>
                      </div>
                    </>
                  );
                }
                if (isOffMarket) {
                  return (
                    <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                      <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#111827] mb-4">
                        Visibility (Off-Market)
                      </h3>
                      <p className="text-[11px] text-[#374151] opacity-70 mb-6 leading-relaxed">
                        Off-market listings are <strong>private</strong>. Tick
                        the checkbox below to make this property visible on the
                        Collings Portal.
                      </p>

                      <div
                        className={`flex items-center justify-between px-3 py-2 rounded-lg border transition-all ${property?.published_on_website ? "border-[#55C5D0] bg-[#55C5D0]/5" : "border-gray-100 bg-white"}`}
                      >
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_website || false}
                            onChange={async (e) => {
                              try {
                                const checked = e.target.checked;
                                await patchCollingsProperty(property.id, {
                                  published_on_website: checked,
                                });
                                setProperty((prev) => ({
                                  ...prev,
                                  published_on_website: checked,
                                }));
                                toast.success(
                                  checked
                                    ? "Published to Collings Portal"
                                    : "Unpublished from Collings Portal",
                                );
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            Collings Portal
                          </span>
                        </div>
                        <span className="text-[10px] text-[#374151] opacity-50 uppercase font-bold tracking-wider">
                          Off-Market Portal only
                        </span>
                      </div>

                      {property?.published_on_website && (
                        <div className="mt-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
                          <label className="block text-[10px] font-bold text-[#374151] uppercase tracking-wider mb-2">
                            🕐 Launch Date &amp; Time (Optional)
                          </label>
                          <input
                            type="datetime-local"
                            className="w-full text-[11px] px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#55C5D0]/20 focus:border-[#55C5D0] outline-none transition-all"
                            value={
                              property?.listing_launch_at
                                ? `${formatMelbourneDatePart(property.listing_launch_at)}T${formatMelbourneTimePart(property.listing_launch_at)}`
                                : ""
                            }
                            onChange={async (e) => {
                              try {
                                const val = datetimeLocalToUtcISOString(e.target.value);
                                await patchCollingsProperty(property.id, {
                                  listing_launch_at: val || null,
                                });
                                setProperty((prev) => ({
                                  ...prev,
                                  listing_launch_at: val || null,
                                }));
                                toast.success("Launch date updated");
                              } catch (err) {
                                toast.error("Failed to update launch date");
                              }
                            }}
                          />
                          <p className="mt-2 text-[9px] text-gray-500 italic">
                            {property?.listing_launch_at
                              ? `Will appear on Collings Portal on ${formatMelbourneDateTime(property.listing_launch_at)}.`
                              : "Leave blank to publish immediately."}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                }
                if (!isOnMarket) return null;
                // "View" links to each public surface: the buyer-portal preview on the
                // Collings Portal row (needs a minted share slug), and the collings.com.au
                // website page on the Collings.com.au row. The website page is keyed by
                // the CRM property id, so it is built automatically for EVERY property and
                // never depends on a share slug (which is why the old portal link on this
                // row was hidden when a slug had not been minted).
                const websiteUrl = property?.id
                  ? `https://www.collings.com.au/property-detail/?properties=${property.id}`
                  : null;
                // Buyer-portal preview page (portal.collings.com.au/p/<slug>) for the
                // Collings Portal row; only available once a share slug is minted.
                const shareSlug = property?.share_slug || property?.share_token;
                const portalUrl = shareSlug
                  ? `${process.env.REACT_APP_BUYER_PORTAL_URL || 'https://portal.collings.com.au'}/p/${shareSlug}`
                  : null;
                // The crawler stores listing ids as a prefixed link-key ("rea_id 12345");
                // strip the prefix for display so the number reads cleanly and fits its
                // column instead of overflowing into the portal label.
                const formatListingId = (raw) =>
                  raw ? (String(raw).replace(/^\s*(rea_id|domain_id|listing_id)\s*/i, '').trim() || String(raw)) : '';
                // REA / Real Commercial resolve a listing by the trailing numeric id;
                // the slug text is decorative (REA rewrites it to the canonical URL on
                // redirect), so a link built from the stored id lands on the live page.
                // Prefer REA's own public listing id (learned from the REA enquiry
                // feed) — that's the id in the realestate.com.au URL. Fall back to
                // rea_listing_id (the crawler link key) for crawler-imported listings.
                const reaId = formatListingId(property?.rea_portal_listing_id || property?.rea_listing_id);
                const slugify = (s) =>
                  String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
                const reaSlugTail = [slugify(property?.suburb), slugify(property?.state)].filter(Boolean).join('-') || 'listing';
                const reaUrl = reaId ? `https://www.realestate.com.au/property-${reaSlugTail}-${reaId}` : null;
                const realcommercialUrl = reaId ? `https://www.realcommercial.com.au/property-${reaSlugTail}-${reaId}` : null;
                return (
                  <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                    <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#111827] mb-8">
                      Visibility (On-Market)
                    </h3>
                    <div className="space-y-4">
                      <div className="flex items-center space-x-3 mb-2">
                        <input
                          type="checkbox"
                          className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          checked={
                            property?.internal_marketing &&
                            (isCommercial ? property?.published_on_realcommercial : property?.published_on_rea) &&
                            property?.published_on_domain &&
                            property?.published_on_collings
                          }
                          onChange={async (e) => {
                            const checked = e.target.checked;
                            // Commercial listings toggle Real Commercial, not the
                            // residential REA feed.
                            const primaryPortal = isCommercial ? 'published_on_realcommercial' : 'published_on_rea';
                            try {
                              const res = await patchCollingsProperty(property.id, {
                                internal_marketing: checked,
                                [primaryPortal]: checked,
                                published_on_domain: checked,
                                published_on_collings: checked,
                              });
                              setProperty((prev) => ({
                                ...prev,
                                internal_marketing: checked,
                                [primaryPortal]: checked,
                                published_on_domain: res.data?.data?.published_on_domain ?? checked,
                                published_on_collings: checked,
                              }));
                              toast.success(
                                checked
                                  ? "All portals enabled"
                                  : "All portals disabled",
                              );
                              // Domain-only advisories (e.g. description trimmed to
                              // Domain's cap) ride on the same response.
                              domainWarningsFromResponse(res.data).forEach((warning) => {
                                toast(warning, { icon: "⚠️", duration: 10000, style: { background: "#FFFBEB", color: "#92400E" } });
                              });
                            } catch (err) {
                              toast.error("Failed to update visibility");
                            }
                          }}
                        />
                        <span className="text-[11px] text-[#374151] opacity-50 font-medium">
                          (tick all)
                        </span>
                      </div>
                      <div className="flex items-center justify-between group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.internal_marketing || false}
                            onChange={async (e) => {
                              try {
                                await patchCollingsProperty(property.id, {
                                  internal_marketing: e.target.checked,
                                });
                                setProperty((prev) => ({
                                  ...prev,
                                  internal_marketing: e.target.checked,
                                }));
                                toast.success(
                                  e.target.checked
                                    ? "Enabled Internal Marketing"
                                    : "Disabled Internal Marketing",
                                );
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            Internal Marketing
                          </span>
                        </div>
                        <div className="flex items-center space-x-6">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" />
                          <div className="w-52 flex justify-start items-center space-x-2">
                            {property?.internal_marketing ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-green-100 text-green-600">
                                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" />
                                Active
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">
                                Inactive
                              </span>
                            )}
                          </div>                        </div>
                      </div>
                      <div className="flex items-center justify-between group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_website || false}
                            onChange={async (e) => {
                              try {
                                await patchCollingsProperty(property.id, {
                                  published_on_website: e.target.checked,
                                });
                                setProperty((prev) => ({
                                  ...prev,
                                  published_on_website: e.target.checked,
                                }));
                                toast.success(
                                  e.target.checked
                                    ? "Published to Collings Portal"
                                    : "Unpublished from Collings Portal",
                                );
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            Collings Portal
                          </span>
                        </div>
                        <div className="flex items-center space-x-6">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" />
                          <div className="w-52 flex justify-start items-center space-x-2">
                            {property?.published_on_website ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">
                                -
                              </span>
                            )}
                            {property?.published_on_website && portalUrl && (
                              <a
                                href={portalUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the buyer-portal preview"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>                        </div>
                      </div>
                      {!isCommercial && (
                      <div className="flex items-center justify-between group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_rea || false}
                            onChange={async (e) => {
                              const newValue = e.target.checked;
                              try {
                                const res = await patchCollingsProperty(property.id, {
                                  published_on_rea: newValue,
                                });
                                // The backend actually pushes to REA now and reverts the
                                // flag if that push fails — trust its response instead of
                                // assuming the checkbox's intent succeeded.
                                setProperty((prev) => ({
                                  ...prev,
                                  published_on_rea: res.data?.data?.published_on_rea ?? newValue,
                                }));
                                const reaResult = (res.data?.portal_sync || []).find((r) => r.portal === "rea");
                                // REA processes uploads asynchronously — "pending" means it
                                // hadn't finished within our check window, not that it failed.
                                if (reaResult?.pending) {
                                  toast(reaResult.reason || "REA is still processing this — check back shortly.");
                                } else if (reaResult && !reaResult.success) {
                                  toast.error(`Failed to ${newValue ? "publish to" : "unpublish from"} REA: ${reaResult.reason}`);
                                } else {
                                  toast.success(newValue ? "Published to REA" : "Unpublished from REA");
                                }
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            realestate.com.au
                          </span>
                        </div>
                        <div className="flex items-center space-x-6">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" title={property?.rea_portal_listing_id || property?.rea_listing_id || ""}>
                            {reaId || "-"}
                          </span>
                          <div className="w-52 flex justify-start items-center space-x-2">
                            {property?.published_on_rea ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">
                                -
                              </span>
                            )}
                            {property?.published_on_rea && reaUrl && (
                              <a
                                href={reaUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the listing on realestate.com.au"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>                        </div>
                      </div>
                      )}
                      {isCommercial && (
                      <div className="flex items-center justify-between group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_realcommercial || false}
                            onChange={async (e) => {
                              const newValue = e.target.checked;
                              try {
                                const res = await patchCollingsProperty(property.id, {
                                  published_on_realcommercial: newValue,
                                });
                                setProperty((prev) => ({
                                  ...prev,
                                  published_on_realcommercial:
                                    res.data?.data?.published_on_realcommercial ?? newValue,
                                }));
                                const rcResult = (res.data?.portal_sync || []).find(
                                  (r) => r.portal === "realcommercial"
                                );
                                if (rcResult?.pending) {
                                  toast(rcResult.reason || "Real Commercial is still processing this — check back shortly.");
                                } else if (rcResult && !rcResult.success) {
                                  toast.error(`Failed to ${newValue ? "upload to" : "withdraw from"} Real Commercial: ${rcResult.reason}`);
                                } else {
                                  toast.success(newValue ? "Uploaded to Real Commercial" : "Withdrawn from Real Commercial");
                                }
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            realcommercial.com.au
                          </span>
                        </div>
                        <div className="flex items-center space-x-6">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" title={property?.rea_portal_listing_id || property?.rea_listing_id || ""}>
                            {reaId || "-"}
                          </span>
                          <div className="w-52 flex justify-start items-center space-x-2">
                            {property?.published_on_realcommercial ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">
                                -
                              </span>
                            )}
                            {property?.published_on_realcommercial && realcommercialUrl && (
                              <a
                                href={realcommercialUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the listing on realcommercial.com.au"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>                        </div>
                      </div>
                      )}
                      <div className="flex items-center justify-between group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_domain || false}
                            onChange={async (e) => {
                              const newValue = e.target.checked;
                              try {
                                const res = await patchCollingsProperty(property.id, {
                                  published_on_domain: newValue,
                                });
                                // The backend pushes to / withdraws from Domain and
                                // reverts the flag if Domain refuses - trust its
                                // response rather than the checkbox's intent.
                                setProperty((prev) => ({
                                  ...prev,
                                  published_on_domain: res.data?.data?.published_on_domain ?? newValue,
                                  domain_listing_id: res.data?.data?.domain_listing_id ?? prev?.domain_listing_id,
                                }));
                                const domainResult = (res.data?.portal_sync || []).find((r) => r.portal === "domain");
                                notifyDomainResult(domainResult, newValue);
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            domain.com.au
                          </span>
                        </div>
                        <div className="flex items-center space-x-6">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" title={property?.domain_listing_id || ""}>
                            {formatListingId(property?.domain_listing_id) || "-"}
                          </span>
                          <div className="w-52 flex justify-start items-center space-x-2">
                            {property?.published_on_domain ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">
                                -
                              </span>
                            )}
                            {(() => {
                              {/* domain.com.au redirects a bare ad id to the full listing URL */}
                              const domainAdId = String(property?.domain_listing_id || "").replace(/\D/g, "");
                              return property?.published_on_domain && domainAdId ? (
                                <a
                                  href={isCommercial ? `https://www.commercialrealestate.com.au/property/${domainAdId}` : `https://www.domain.com.au/${domainAdId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Open the live Domain listing"
                                  className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                                >
                                  <ExternalLink className="w-3 h-3" />
                                  View
                                </a>
                              ) : null;
                            })()}
                          </div>                        </div>
                      </div>
                      <div className="flex items-center justify-between group">
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            checked={property?.published_on_collings || false}
                            onChange={async (e) => {
                              try {
                                await patchCollingsProperty(property.id, {
                                  published_on_collings: e.target.checked,
                                });
                                setProperty((prev) => ({
                                  ...prev,
                                  published_on_collings: e.target.checked,
                                }));
                                toast.success(
                                  e.target.checked
                                    ? "Published to Collings.com.au"
                                    : "Unpublished from Collings.com.au",
                                );
                              } catch (err) {
                                toast.error("Failed to update visibility");
                              }
                            }}
                            className="w-3.5 h-3.5 rounded border-gray-300 text-[#55C5D0] focus:ring-[#55C5D0] cursor-pointer"
                          />
                          <span className="text-[11px] text-[#374151] font-medium">
                            Collings.com.au
                          </span>
                        </div>
                        <div className="flex items-center space-x-6">
                          <span className="text-[11px] text-[#374151] w-16 text-right opacity-70 truncate" />
                          <div className="w-52 flex justify-start items-center space-x-2">
                            {property?.published_on_collings ? (
                              <span className="text-[9px] px-2.5 py-0.5 rounded-full font-bold flex items-center shadow-sm whitespace-nowrap bg-cyan-100 text-[#55C5D0]">
                                Published
                              </span>
                            ) : (
                              <span className="text-[11px] text-[#374151] opacity-50">
                                -
                              </span>
                            )}
                            {property?.published_on_collings && websiteUrl && (
                              <a
                                href={websiteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open the live listing on collings.com.au"
                                className="inline-flex items-center gap-1 text-[10px] font-bold text-[#55C5D0] hover:underline whitespace-nowrap"
                              >
                                <ExternalLink className="w-3 h-3" />
                                View
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {!isLease && (
                <ComplianceChecklistCard
                  propertyId={params.id}
                  onOpenFull={() => setActiveTab("compliance")}
                />
              )}

              <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
                <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-2">
                  Campaign Representatives
                </h3>
                <p className="text-[11px] text-[#374151] opacity-70 mb-10 font-medium leading-relaxed">
                  Select which agents are displayed as the official contacts for
                  this campaign.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-[11px] text-[#374151] mb-2 font-medium">
                      Primary Agent
                    </label>
                    <div className="relative group">
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={property?.agent?.id || ""}
                        onChange={async (e) => {
                          const agentId = e.target.value;
                          try {
                            await updateCollingsProperty(property.id, {
                              agent_id: agentId,
                            });
                            invalidateCache.collingsProperties();
                            invalidateCache.publicProperties();
                            const updatedAgent =
                              agents.find(
                                (a) => String(a.id) === String(agentId),
                              ) || null;
                            setProperty((prev) => ({
                              ...prev,
                              agent: updatedAgent,
                              agent_id: agentId,
                            }));
                            toast.success("Primary agent updated");
                          } catch (err) {
                            toast.error("Failed to update agent");
                          }
                        }}
                        disabled={agentsLoading}
                      >
                        <option value="">Select Agent</option>
                        {agents.map((agent) => {
                          const displayName =
                            agent.name ||
                            `${agent.first_name || ""} ${agent.last_name || ""}`.trim() ||
                            agent.email ||
                            "Unknown Agent";
                          return (
                            <option key={agent.id} value={agent.id}>
                              {displayName}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronDown className="w-4 h-4 text-gray-400 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none group-hover:text-[#55C5D0]" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-[11px] text-[#374151] mb-2 font-medium">
                      Secondary Agent (Optional)
                    </label>
                    <div className="relative group">
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={secondAgentId}
                        onChange={async (e) => {
                          const agentId = e.target.value;
                          setSecondAgentId(agentId || "");
                          setMakeSecondaryAgentOnListing(!!agentId);
                          const coAgentValue = agentId || "";
                          try {
                            await patchCollingsProperty(property.id, {
                              co_agent_id: coAgentValue,
                            });
                            const updatedCoAgent = coAgentValue
                              ? agents.find(
                                  (a) => String(a.id) === coAgentValue,
                                ) || null
                              : null;
                            setProperty((prev) => ({
                              ...prev,
                              co_agent: updatedCoAgent,
                              extra_info: {
                                ...(prev.extra_info || {}),
                                co_agent: updatedCoAgent
                                  ? {
                                      id: updatedCoAgent.id,
                                      name: updatedCoAgent.name,
                                      email: updatedCoAgent.email,
                                    }
                                  : null,
                                co_agent_id: coAgentValue || null,
                              },
                            }));
                            toast.success(
                              coAgentValue
                                ? "Secondary agent updated"
                                : "Secondary agent removed",
                            );
                          } catch (err) {
                            toast.error("Failed to update agent");
                          }
                        }}
                        disabled={agentsLoading}
                      >
                        <option value="">None</option>
                        {agents.map((agent) => {
                          const displayName =
                            agent.name ||
                            `${agent.first_name || ""} ${agent.last_name || ""}`.trim() ||
                            agent.email ||
                            "Unknown Agent";
                          return (
                            <option key={agent.id} value={String(agent.id)}>
                              {displayName}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronDown className="w-4 h-4 text-gray-400 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none group-hover:text-[#55C5D0]" />
                    </div>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-2">
                      This agent will have access to the listing but will not be
                      shown on marketing.
                    </p>
                    <label className="block text-[11px] text-[#374151] mb-2 font-medium">
                      Third Agent (Optional)
                    </label>
                    <div className="relative group max-w-md">
                      <select
                        className="w-full text-xs font-medium border border-gray-100 rounded-lg px-4 py-3 appearance-none bg-white focus:border-[#55C5D0] focus:ring-1 focus:ring-[#55C5D0] transition-all cursor-pointer"
                        value={String(
                          property?.tertiary_agent?.id ??
                            property?.extra_info?.tertiary_agent?.id ??
                            "",
                        )}
                        onChange={async (e) => {
                          const agentId = e.target.value;
                          const value = agentId === "" ? "" : String(agentId);
                          try {
                            await patchCollingsProperty(property.id, {
                              tertiary_agent_id: value,
                            });
                            const updatedTertiary = value
                              ? agents.find((a) => String(a.id) === value) ||
                                null
                              : null;
                            setProperty((prev) => ({
                              ...prev,
                              tertiary_agent: updatedTertiary,
                              extra_info: {
                                ...(prev.extra_info || {}),
                                tertiary_agent: updatedTertiary
                                  ? {
                                      id: updatedTertiary.id,
                                      name: updatedTertiary.name,
                                      email: updatedTertiary.email,
                                    }
                                  : null,
                                tertiary_agent_id: value || null,
                              },
                            }));
                            invalidateCache.collingsProperties();
                            invalidateCache.publicProperties();
                            toast.success(
                              value
                                ? "Third agent updated"
                                : "Third agent cleared",
                            );
                          } catch (err) {
                            toast.error("Failed to update agent");
                          }
                        }}
                        disabled={agentsLoading}
                      >
                        <option value="">None</option>
                        {agents.map((agent) => {
                          const displayName =
                            agent.name ||
                            `${agent.first_name || ""} ${agent.last_name || ""}`.trim() ||
                            agent.email ||
                            "Unknown Agent";
                          return (
                            <option key={agent.id} value={String(agent.id)}>
                              {displayName}
                            </option>
                          );
                        })}
                      </select>
                      <ChevronDown className="w-4 h-4 text-gray-400 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none group-hover:text-[#55C5D0]" />
                    </div>
                  </div>
                </div>

                {/* Selected primary agent full details (name, email, phone) - like buyer portal */}
                {(() => {
                  const primaryAgent =
                    agents.find(
                      (a) =>
                        a.id === property?.agent_id ||
                        a.id === property?.agent?.id,
                    ) || property?.agent;
                  if (!primaryAgent) return null;
                  const displayName =
                    primaryAgent.name ||
                    `${primaryAgent.first_name || ""} ${primaryAgent.last_name || ""}`.trim() ||
                    primaryAgent.email ||
                    "Property Agent";
                  const phone =
                    primaryAgent.phone ||
                    primaryAgent.mobile ||
                    primaryAgent.mobile_number ||
                    primaryAgent.phone_number;
                  return (
                    <div className="mt-6 p-4 sm:p-5 rounded-xl border border-gray-100 bg-gray-50/50">
                      <h3 className="text-[12.93px] font-sans font-medium text-[#374151] mb-3 sm:mb-4">
                        Property Agent (Primary)
                      </h3>
                      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                        {primaryAgent.photo ? (
                          <img
                            src={primaryAgent.photo}
                            alt={displayName}
                            className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#55C5D0]/20"
                          />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#55C5D0]/10 flex items-center justify-center text-[#55C5D0] text-base sm:text-lg font-bold">
                            {displayName.charAt(0) || "A"}
                          </div>
                        )}
                        <div>
                          <p className="text-[13px] sm:text-[14px] font-bold text-[#374151]">
                            {displayName}
                          </p>
                          {(primaryAgent.title || primaryAgent.role) && (
                            <p className="text-[11px] sm:text-[12px] text-[#6B7280]">
                              {primaryAgent.title || primaryAgent.role}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="space-y-2 sm:space-y-2.5">
                        {primaryAgent.email && (
                          <a
                            href={`mailto:${primaryAgent.email}`}
                            className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group"
                          >
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors">
                              <Mail className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium">
                              {primaryAgent.email}
                            </span>
                          </a>
                        )}
                        {phone && (
                          <a
                            href={`tel:${phone}`}
                            className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group"
                          >
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors">
                              <Phone className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium">
                              {phone}
                            </span>
                          </a>
                        )}
                        {!primaryAgent.email && !phone && (
                          <p className="text-[11px] text-[#6B7280] font-medium">
                            No contact details on file for this agent.
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Selected secondary agent full details when set */}
                {(() => {
                  const coAgentId =
                    property?.co_agent?.id || property?.co_agent;
                  const secondaryAgent =
                    typeof coAgentId !== "undefined" && coAgentId
                      ? agents.find((a) => a.id === coAgentId) ||
                        property?.co_agent
                      : null;
                  if (!secondaryAgent) return null;
                  const displayName =
                    secondaryAgent.name ||
                    `${secondaryAgent.first_name || ""} ${secondaryAgent.last_name || ""}`.trim() ||
                    secondaryAgent.email ||
                    "Secondary Agent";
                  const phone =
                    secondaryAgent.phone ||
                    secondaryAgent.mobile ||
                    secondaryAgent.mobile_number ||
                    secondaryAgent.phone_number;
                  return (
                    <div className="mt-4 p-4 sm:p-5 rounded-xl border border-gray-100 bg-gray-50/50">
                      <h3 className="text-[12.93px] font-sans font-medium text-[#374151] mb-3 sm:mb-4">
                        Property Agent (Secondary)
                      </h3>
                      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                        {secondaryAgent.photo ? (
                          <img
                            src={secondaryAgent.photo}
                            alt={displayName}
                            className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#55C5D0]/20"
                          />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#55C5D0]/10 flex items-center justify-center text-[#55C5D0] text-base sm:text-lg font-bold">
                            {displayName.charAt(0) || "A"}
                          </div>
                        )}
                        <div>
                          <p className="text-[13px] sm:text-[14px] font-bold text-[#374151]">
                            {displayName}
                          </p>
                          {(secondaryAgent.title || secondaryAgent.role) && (
                            <p className="text-[11px] sm:text-[12px] text-[#6B7280]">
                              {secondaryAgent.title || secondaryAgent.role}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="space-y-2 sm:space-y-2.5">
                        {secondaryAgent.email && (
                          <a
                            href={`mailto:${secondaryAgent.email}`}
                            className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group"
                          >
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors">
                              <Mail className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium">
                              {secondaryAgent.email}
                            </span>
                          </a>
                        )}
                        {phone && (
                          <a
                            href={`tel:${phone}`}
                            className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group"
                          >
                            <div className="p-1.5 bg-white rounded-lg border border-gray-100 group-hover:border-[#55C5D0]/30 transition-colors">
                              <Phone className="w-4 h-4 text-[#55C5D0]" />
                            </div>
                            <span className="text-[11px] sm:text-[12px] font-medium">
                              {phone}
                            </span>
                          </a>
                        )}
                        {!secondaryAgent.email && !phone && (
                          <p className="text-[11px] text-[#6B7280] font-medium">
                            No contact details on file for this agent.
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Third agent (access only, not on marketing) */}
                {(() => {
                  const tertId =
                    property?.tertiary_agent?.id ??
                    property?.tertiary_agent ??
                    property?.extra_info?.tertiary_agent?.id;
                  const tertiaryAgent =
                    typeof tertId !== "undefined" && tertId
                      ? agents.find((a) => a.id === tertId) ||
                        property?.tertiary_agent ||
                        property?.extra_info?.tertiary_agent
                      : null;
                  if (!tertiaryAgent) return null;
                  const displayName =
                    tertiaryAgent.name ||
                    `${tertiaryAgent.first_name || ""} ${tertiaryAgent.last_name || ""}`.trim() ||
                    tertiaryAgent.email ||
                    "Third Agent";
                  const phone =
                    tertiaryAgent.phone ||
                    tertiaryAgent.mobile ||
                    tertiaryAgent.mobile_number ||
                    tertiaryAgent.phone_number;
                  return (
                    <div className="mt-4 p-4 sm:p-5 rounded-xl border border-gray-100 bg-amber-50/50">
                      <h3 className="text-[12.93px] font-sans font-medium text-[#374151] mb-1">
                        Third Agent (access only, not on marketing)
                      </h3>
                      <p className="text-[10px] text-amber-700 mb-3">
                        This agent has access to the listing but is not shown on
                        marketing.
                      </p>
                      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                        {tertiaryAgent.photo ? (
                          <img
                            src={tertiaryAgent.photo}
                            alt={displayName}
                            className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#55C5D0]/20"
                          />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#55C5D0]/10 flex items-center justify-center text-[#55C5D0] text-base sm:text-lg font-bold">
                            {displayName.charAt(0) || "A"}
                          </div>
                        )}
                        <div>
                          <p className="text-[13px] sm:text-[14px] font-bold text-[#374151]">
                            {displayName}
                          </p>
                          {(tertiaryAgent.title || tertiaryAgent.role) && (
                            <p className="text-[11px] sm:text-[12px] text-[#6B7280]">
                              {tertiaryAgent.title || tertiaryAgent.role}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="space-y-2 sm:space-y-2.5">
                        {tertiaryAgent.email && (
                          <a
                            href={`mailto:${tertiaryAgent.email}`}
                            className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group"
                          >
                            <Mail className="w-4 h-4 text-[#55C5D0]" />
                            <span className="text-[11px] sm:text-[12px] font-medium">
                              {tertiaryAgent.email}
                            </span>
                          </a>
                        )}
                        {phone && (
                          <a
                            href={`tel:${phone}`}
                            className="flex items-center gap-2 sm:gap-2.5 text-[#374151] hover:text-[#55C5D0] transition-colors group"
                          >
                            <Phone className="w-4 h-4 text-[#55C5D0]" />
                            <span className="text-[11px] sm:text-[12px] font-medium">
                              {phone}
                            </span>
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })()}

                <p className="text-[10px] text-[#374151] opacity-60 mb-10 font-medium mt-6">
                  Selected agents (Primary and, when ticked, Secondary) will
                  appear on buyer-facing listings and enquiry forms.
                </p>

                <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-4">
                  Internal Notes (Optional)
                </h3>
                <textarea
                  className="w-full text-[11px] border border-gray-100 rounded-xl p-4 min-h-[80px] bg-white hover:border-gray-200 focus:border-[#55C5D0] transition-all font-medium placeholder:text-[#374151]/50 placeholder:text-[11px] outline-none resize-y"
                  placeholder="Add internal notes about the Property Price Statement or campaign.."
                />
              </div>
            </div>

            {/* Property Price Statement is a sale-only compliance document; not applicable to rentals. */}
            {!isLease && (
            <div className="bg-white rounded-xl border border-gray-100 p-4 sm:p-6 md:p-8 shadow-sm flex flex-col w-full max-w-full">
              <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-2 tracking-tight">
                Property Price Statement
              </h3>
              <p className="text-[11px] text-[#374151] opacity-70 mb-6 sm:mb-10 font-medium leading-relaxed">
                Official Property Price Statement (PPS) for this property, used
                for compliance and buyer disclosure.
              </p>

              <div className="mb-8 sm:mb-12">
                <h4 className="text-[12px] font-bold text-[#374151] mb-4 sm:mb-6 font-sans">
                  Property Price Statement (PDF)
                </h4>
                {(() => {
                  const soiDoc = sortedSoiDocs[0];
                  const previousSoi = sortedSoiDocs.slice(1);
                  if (soiDoc) {
                    return (
                      <div className="bg-[#F8F9FB] rounded-xl p-4 sm:p-6 md:p-8 border border-gray-100/50">
                        <div className="flex flex-col gap-4">
                          <div className="space-y-3 sm:space-y-4 min-w-0 flex-1 order-1">
                            <div>
                              <span className="text-[11px] text-[#374151] font-bold">
                                Current Statement
                              </span>
                            </div>
                            <div className="space-y-2">
                              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 text-[11px] min-w-0">
                                <span className="text-[#374151] font-bold flex-shrink-0">
                                  File:
                                </span>
                                <span
                                  className="text-[#374151] opacity-60 font-medium break-words [overflow-wrap:anywhere]"
                                  title={soiDoc.name}
                                >
                                  {soiDoc.name ||
                                    "Property_Price_Statement.pdf"}
                                </span>
                              </div>
                              <div className="flex items-center space-x-2 text-[11px]">
                                <span className="text-[#374151] font-bold whitespace-nowrap">
                                  Last Updated:
                                </span>
                                <span className="text-[#374151] opacity-60 font-medium whitespace-nowrap">
                                  {soiDoc.uploaded_at
                                    ? new Date(
                                        soiDoc.uploaded_at,
                                      ).toLocaleDateString("en-AU", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric",
                                      })
                                    : "N/A"}
                                </span>
                              </div>
                              <div className="flex items-center space-x-2 text-[11px]">
                                <span className="text-[#374151] font-bold whitespace-nowrap">
                                  Uploaded by:
                                </span>
                                <span className="text-[#55C5D0] font-medium underline underline-offset-2 break-words min-w-0 cursor-pointer">
                                  {property?.agent?.name || "Agent"}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-row flex-wrap gap-[clamp(0.25rem,1vw,0.5rem)] w-full flex-shrink-0 order-2">
                            <a
                              href={soiDoc.file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-flex items-center justify-center flex-1 min-w-[clamp(80px,22vw,140px)] md:min-w-0 md:w-full py-[clamp(0.5rem,1.2vh,0.65rem)] px-[clamp(0.75rem,2vw,1rem)] bg-[#E8F5E9] text-[#2E7D32] rounded-lg text-[clamp(9px,2vw,11px)] font-bold tracking-tight border border-[#C8E6C9] hover:bg-[#C8E6C9] transition-all text-center whitespace-nowrap"
                            >
                              Download
                            </a>
                            <button
                              type="button"
                              onClick={handleReplaceSOI}
                              disabled={soiUploading}
                              className="inline-flex items-center justify-center flex-1 min-w-[clamp(70px,18vw,120px)] md:min-w-0 md:w-full py-[clamp(0.5rem,1.2vh,0.65rem)] px-[clamp(0.75rem,2vw,1rem)] bg-[#E3F2FD] text-[#1976D2] rounded-lg text-[clamp(9px,2vw,11px)] font-bold tracking-tight border border-[#BBDEFB] hover:bg-[#BBDEFB] transition-all disabled:opacity-50 whitespace-nowrap"
                            >
                              Replace
                            </button>
                            <button
                              type="button"
                              onClick={handleRemoveSOI}
                              disabled={soiUploading}
                              className="inline-flex items-center justify-center flex-1 min-w-[clamp(70px,18vw,120px)] md:min-w-0 md:w-full py-[clamp(0.5rem,1.2vh,0.65rem)] px-[clamp(0.75rem,2vw,1rem)] bg-[#FFEBEE] text-[#D32F2F] rounded-lg text-[clamp(9px,2vw,11px)] font-bold tracking-tight border border-[#FFCDD2] hover:bg-[#FFCDD2] transition-all disabled:opacity-50 whitespace-nowrap"
                            >
                              Remove
                            </button>
                          </div>
                          {previousSoi.length > 0 && (
                            <div className="w-full order-3 pt-3 mt-1 border-t border-gray-200/70 space-y-2">
                              <span className="text-[11px] text-[#374151] font-bold">Previous versions</span>
                              {previousSoi.map((doc) => (
                                <div key={doc.id} className="flex items-center justify-between gap-2 text-[11px] min-w-0">
                                  <span className="text-[#374151] opacity-60 font-medium break-words [overflow-wrap:anywhere] min-w-0" title={doc.name}>{doc.name || 'Property_Price_Statement.pdf'}</span>
                                  <span className="text-[#374151] opacity-50 whitespace-nowrap flex-shrink-0">{doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}</span>
                                  <a href={doc.file} target="_blank" rel="noopener noreferrer" className="text-[#55C5D0] font-bold whitespace-nowrap flex-shrink-0 hover:underline">Download</a>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className="bg-[#F8F9FB] rounded-xl p-6 sm:p-8 border border-gray-100/50 text-center">
                        <p className="text-[11px] text-[#374151] opacity-60 font-medium">
                          No Property Price Statement uploaded yet.
                        </p>
                      </div>
                    );
                  }
                })()}
              </div>

              {(() => {
                const soiDoc = sortedSoiDocs[0];
                // Only show drag-and-drop upload area when no document exists
                if (!soiDoc) {
                  return (
                    <div>
                      <h4 className="text-[12px] font-bold text-[#374151] mb-4 sm:mb-6 font-sans">
                        Upload New Property Price Statement
                      </h4>
                      <input
                        ref={soiFileInputRef}
                        type="file"
                        accept=".pdf,application/pdf"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) handleSOIUpload([file]);
                        }}
                      />
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          !soiUploading && soiFileInputRef.current?.click()
                        }
                        onKeyDown={(e) =>
                          e.key === "Enter" &&
                          !soiUploading &&
                          soiFileInputRef.current?.click()
                        }
                        onDragOver={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onDrop={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (soiUploading) return;
                          const file = e.dataTransfer?.files?.[0];
                          if (file) handleSOIUpload([file]);
                        }}
                        className="border border-dashed border-gray-200 rounded-2xl p-8 sm:p-12 md:p-16 flex flex-col items-center justify-center text-center hover:bg-gray-50 hover:border-[#55C5D0]/30 transition-all cursor-pointer group bg-white touch-manipulation disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        <div className="w-16 h-12 mb-6">
                          <svg
                            viewBox="0 0 64 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full h-full text-[#55C5D0]"
                          >
                            <path
                              d="M48 16C46.5 16 45.1 16.3 43.8 16.9C42.2 10.6 36.6 6 30 6C23.4 6 17.8 10.6 16.2 16.9C14.9 16.3 13.5 16 12 16C5.4 16 0 21.4 0 28C0 34.6 5.4 40 12 40H48C54.6 40 60 34.6 60 28C60 21.4 54.6 16 48 16Z"
                              fill="currentColor"
                            />
                            <path
                              d="M30 18L22 26H28V34H32V26H38L30 18Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div className="space-y-2">
                          {soiUploading ? (
                            <p className="text-[11.5px] font-medium text-[#374151]">
                              Uploading...
                            </p>
                          ) : (
                            <>
                              <p className="text-[11.5px] font-medium text-[#374151]">
                                <span className="font-extrabold">
                                  Drag & drop
                                </span>{" "}
                                Property Price Statement
                              </p>
                              <p className="text-[11.5px] text-[#374151] opacity-70 font-medium">
                                PDF here or{" "}
                                <span className="font-extrabold">click</span> to
                                upload
                              </p>
                              <p className="text-[10px] text-[#374151] opacity-40 font-medium pt-1">
                                Accepted format: PDF - Max file size: 2MB
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <p className="text-[10px] text-[#374151] opacity-60 mt-8 font-medium leading-relaxed">
                        This document is required before the property can be
                        publicly shared.
                      </p>
                    </div>
                  );
                }
                return null;
              })()}
            </div>
            )}
          </div>

          <div className="bg-white rounded-2xl border border-gray-100 p-10 shadow-sm mt-6">
            <div className="flex items-center justify-between mb-10">
              <div className="flex items-center space-x-4">
                <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">
                  About the Property
                </h3>
              </div>
              {isEditingDescription ? (
                <div className="flex space-x-2">
                  <button
                    onClick={() => setIsEditingDescription(false)}
                    className="px-5 py-2 bg-gray-100 text-gray-700 rounded-xl text-xs font-black tracking-widest transition-all uppercase"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSaveDescription}
                    disabled={isUpdating}
                    className="px-5 py-2 bg-[#55C5D0] text-white rounded-xl text-xs font-black tracking-widest transition-all uppercase disabled:opacity-50"
                  >
                    {isUpdating ? "Saving..." : "Save Description"}
                  </button>
                </div>
              ) : (
                <button
                  onClick={handleEditDescription}
                  className="px-5 py-2 bg-[#ECECEC] text-[#374151] rounded-xl text-xs font-black tracking-widest transition-all uppercase"
                >
                  Edit Description
                </button>
              )}
            </div>

            {isEditingDescription ? (
              <>
                <textarea
                  value={descriptionEdit}
                  onChange={(e) => setDescriptionEdit(e.target.value)}
                  className="w-full min-h-[400px] p-6 text-sm text-[#374151] font-medium border border-gray-100 rounded-xl focus:border-[#55C5D0] outline-none leading-relaxed placeholder:text-[#374151]/40"
                  placeholder="Write a compelling property description..."
                />
                <DomainDescriptionCounter text={descriptionEdit} />
              </>
            ) : (
              <div className="text-[#374151] text-[13px] leading-[1.8] font-medium space-y-8 max-w-full">
                {formatDescription(property.description).map(
                  (paragraph, index) => (
                    <p key={index} className="opacity-95">
                      {paragraph}
                    </p>
                  ),
                )}
              </div>
            )}
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
            <div className="flex items-center justify-between mb-8">
              <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151]">
                Property Information
              </h3>
              {isEditingInfo ? (
                <div className="flex space-x-2">
                  <button
                    onClick={() => setIsEditingInfo(false)}
                    className="px-3 py-1 bg-[#ECECEC] text-[#374151] rounded-md text-[10px] font-bold transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSaveInfo}
                    disabled={isUpdating}
                    className="px-3 py-1 bg-[#55C5D0] text-white rounded-md text-[10px] font-bold transition-all disabled:opacity-50"
                  >
                    {isUpdating ? "Saving..." : "Save"}
                  </button>
                </div>
              ) : (
                <button
                  onClick={handleEditInfo}
                  className="px-3 py-1 bg-[#ECECEC] text-[#374151] rounded-md text-[10px] font-bold transition-all"
                >
                  Edit
                </button>
              )}
            </div>

            {isEditingInfo ? (
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Price
                  </span>
                  <input
                    type="text"
                    value={editForm.price}
                    onChange={(e) => handleInputChange("price", e.target.value)}
                    className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                  />
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Weekly Rent
                  </span>
                  <input
                    type="text"
                    value={editForm.weekly_rent ?? ""}
                    onChange={(e) =>
                      handleInputChange("weekly_rent", e.target.value)
                    }
                    placeholder="Optional"
                    className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                  />
                </div>
                {isLease && (
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Bond
                  </span>
                  <input
                    type="text"
                    value={editForm.bond ?? ""}
                    onChange={(e) => handleInputChange("bond", e.target.value)}
                    placeholder="Auto from rent"
                    className="w-24 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] text-[#374151]"
                  />
                </div>
                )}
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Type
                  </span>
                  <select
                    value={editForm.property_type}
                    onChange={(e) =>
                      handleInputChange("property_type", e.target.value)
                    }
                    className="w-32 text-right text-xs font-bold border border-gray-100 rounded bg-gray-50 px-2 py-1 outline-none text-[#374151]"
                  >
                    <option value="Residential">residential</option>
                    <option value="Commercial">commercial</option>
                    <option value="Land">land</option>
                  </select>
                </div>
                {[
                  { field: "beds", label: "Bedrooms" },
                  { field: "baths", label: "Bathrooms" },
                  { field: "garages", label: "Garage" },
                  { field: "car_ports", label: "Carports" },
                  { field: "open_spaces", label: "Open parking" },
                ].map((fieldOrConfig) => {
                  const field = fieldOrConfig.field;
                  const label = fieldOrConfig.label;
                  return (
                  <div
                    key={field}
                    className="flex items-center justify-between"
                  >
                    <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                      {label}
                    </span>
                    <div className="flex items-center space-x-1 border border-gray-100 rounded-md bg-gray-50 overflow-hidden">
                      <button
                        onClick={() =>
                          handleInputChange(
                            field,
                            Math.max(0, (editForm[field] || 0) - 1),
                          )
                        }
                        className="px-2 py-1 hover:bg-gray-200 text-[#374151] font-bold"
                      >
                        -
                      </button>
                      <span className="w-8 text-center text-xs font-bold text-[#374151]">
                        {editForm[field] || 0}
                      </span>
                      <button
                        onClick={() =>
                          handleInputChange(field, (editForm[field] || 0) + 1)
                        }
                        className="px-2 py-1 hover:bg-gray-200 text-[#374151] font-bold"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  );
                })}
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Floor Area (m²)
                  </span>
                  <div className="relative">
                    <input
                      type="number"
                      value={editForm.floor_area}
                      onChange={(e) =>
                        handleInputChange("floor_area", e.target.value)
                      }
                      className="w-20 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] pr-6 text-[#374151]"
                    />
                    <span className="absolute right-1.5 top-1/2 -translate-y-1/2 text-[9px] text-[#374151] opacity-60 font-bold">
                      m²
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                    Land Area (m²)
                  </span>
                  <div className="relative">
                    <input
                      type="number"
                      value={editForm.land_area}
                      onChange={(e) =>
                        handleInputChange("land_area", e.target.value)
                      }
                      className="w-20 text-right text-xs font-bold border border-gray-200 rounded px-2 py-1 outline-none focus:border-[#55C5D0] pr-6 text-[#374151]"
                    />
                    <span className="absolute right-1.5 top-1/2 -translate-y-1/2 text-[9px] text-[#374151] opacity-60 font-bold">
                      m²
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="space-y-5">
                {[
                  {
                    label: "Price",
                    value: formatPriceDisplay(property),
                    isPrice: true,
                  },
                  ...(property?.weekly_rent != null &&
                  property.weekly_rent !== ""
                    ? [
                        {
                          label: "Weekly Rent",
                          value: formatPrice(property.weekly_rent),
                          isPrice: true,
                        },
                      ]
                    : []),
                  ...(isLease &&
                  property?.bond != null &&
                  property.bond !== ""
                    ? [
                        {
                          label: "Bond",
                          value: formatPrice(property.bond),
                          isPrice: true,
                        },
                      ]
                    : []),
                  {
                    label: "Class",
                    value: String(
                      property.extra_info?.property_class ||
                        property.property_class ||
                        "residential",
                    ).toLowerCase(),
                    isBadge: true,
                  },
                  {
                    label: "Type",
                    value: String(
                      property.property_type || "residential",
                    ).toLowerCase(),
                    isBadge: true,
                  },
                  { label: "Bedrooms", value: property.beds ?? 0 },
                  { label: "Bathrooms", value: property.baths ?? 0 },
                  { label: "Garage", value: property.garages ?? property.parkings ?? property.parking_spaces ?? 0 },
                  { label: "Carports", value: property.car_ports ?? 0 },
                  { label: "Open parking", value: property.open_spaces ?? property.open_space ?? 0 },
                  { label: "Floor Area (m²)", value: property.floor_area || 0 },
                  {
                    label: "Land Area (m²)",
                    value: property.land_area || "N/A",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-1"
                  >
                    <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151] opacity-70">
                      {item.label}
                    </span>
                    {item.isBadge ? (
                      <span className="text-[11px] font-semibold bg-[#E0F2FF] text-[#0066CC] px-2.5 py-0.5 rounded-full lowercase">
                        {item.value}
                      </span>
                    ) : item.isPrice ? (
                      <span className="text-lg font-bold text-[#55C5D0]">
                        {item.value}
                      </span>
                    ) : item.isPriceText ? (
                      <span className="text-[11px] font-medium text-gray-500 italic">
                        {item.value}
                      </span>
                    ) : (
                      <span className="font-sans font-bold text-[12.93px] leading-[18.75px] text-[#374151]">
                        {item.value}
                        {item.label.includes("Area") ? "m²" : ""}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
            <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-8">
              Listing Details
            </h3>
            <div className="space-y-5">
              <div className="flex items-center justify-between">
                <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                  Listing ID
                </span>
                <span className="text-xs font-medium text-[#374151]">
                  {params.id.slice(-8).toUpperCase()}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                  Created
                </span>
                <span className="text-xs font-medium text-[#374151]">
                  {formatDate(property.created_at)}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-sans font-normal text-[11.5px] leading-[17.24px] text-[#374151]">
                  Status
                </span>
                <span className="text-[10px] px-3 py-1 bg-[#E1F5FE] text-[#039BE5] rounded-full font-bold">
                  Active
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
            <h3 className="font-sans font-medium text-[12.93px] leading-[18.75px] text-[#374151] mb-8">
              Location
            </h3>
            <div className="flex items-start space-x-3">
              <div className="mt-0.5">
                <MapPin className="w-4 h-4 text-[#374151] opacity-40" />
              </div>
              <div className="space-y-1">
                <p className="text-xs font-bold text-[#374151]">
                  {property.address || "405 High Street"}
                </p>
                <p className="text-[11px] text-[#374151] opacity-70 font-normal leading-relaxed">
                  {property.address}, Northcote, VIC, 3070
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex-1 flex flex-col bg-[#F8FAFC] min-h-screen -mx-[14px] -my-3 sm:-mx-4 sm:-my-4 md:-m-6">
      {/* Sticky only on md+ — on mobile the action button grid makes the header
          too tall, so it pins over and clips the tab nav underneath. */}
      <div className="bg-white border-b border-gray-100 md:sticky md:top-0 md:z-40 shadow-sm">
        <div className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-6">
          <div className="flex flex-col gap-4">
            <div className="flex items-start sm:items-center gap-3 sm:gap-4 min-w-0">
              <button
                onClick={() => navigate(-1)}
                className="w-10 h-10 flex-shrink-0 bg-white border border-gray-200 rounded-xl flex items-center justify-center hover:bg-gray-50 transition-colors shadow-sm"
              >
                <ArrowLeft className="w-5 h-5 text-[#374151]" />
              </button>
              <div className="flex flex-col space-y-1 min-w-0 flex-1">
                <div className="flex items-center space-x-3 flex-wrap gap-1 mb-1">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 text-white text-[10px] font-bold rounded-md leading-tight flex-shrink-0 ${
                      (property?.status?.name || property?.status || "")
                        .toLowerCase()
                        .includes("off")
                        ? "bg-orange-500"
                        : (property?.status?.name || property?.status || "")
                              .toLowerCase()
                              .includes("sold")
                          ? "bg-blue-500"
                          : (property?.status?.name || property?.status || "")
                                .toLowerCase()
                                .includes("prospect")
                            ? "bg-yellow-500"
                            : "bg-[#4CAF50]" // Green for Active/On Market
                    }`}
                  >
                    {property?.status?.name || property?.status || "Active"}
                  </span>
                  {/* Scheduled Badge - only shown if launch date is in the future */}
                  {property?.listing_launch_at &&
                    new Date(property.listing_launch_at) > new Date() && (
                      <span className="inline-flex items-center px-2.5 py-0.5 bg-[#55C5D0] text-white text-[10px] font-bold rounded-md leading-tight flex-shrink-0 animate-pulse">
                        🕐 SCHEDULED:{" "}
                        {formatMelbourneDateTime(property.listing_launch_at)}
                      </span>
                    )}
                  <PublicMatchBadge status={property?.public_match_status} />
                </div>
                <h1 className="text-xl sm:text-2xl md:text-3xl font-black text-[#374151] tracking-tighter leading-tight break-words">
                  {property.address}
                </h1>
                <CampaignSwitch source="collings" id={params.id} />
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 sm:gap-4 flex-shrink-0">
              <button
                onClick={() =>
                  navigate(`/collings-properties/edit/${params.id}`)
                }
                className="flex items-center justify-center space-x-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-[#2D3139] hover:bg-black text-white rounded-xl text-[10px] font-black transition-all shadow-xl shadow-black/5 active:scale-95 uppercase tracking-widest flex-1 sm:flex-none min-w-0"
              >
                <Edit className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">EDIT PROPERTY</span>
              </button>
              <button
                onClick={() => setShowDuplicateModal(true)}
                disabled={isDuplicating}
                className="flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 bg-[#E8F4FA] hover:bg-[#D6EBF5] text-[#2C5F86] border-[#C9DDEA] disabled:opacity-50 disabled:cursor-not-allowed"
                title="Duplicate property (switch sales ↔ rental)"
              >
                <Copy className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">Duplicate</span>
              </button>
              {/* Green "Listed" button — won, awaiting portal upload. Shown on an
                  Appraisal (click to mark Listed) and on an already Listed
                  property (filled green indicator). Monday 13225851756. */}
              {(isAppraisalStatus || isListedStatus) && (
                <button
                  onClick={handleMarkListed}
                  disabled={isMarkingListed || isListedStatus}
                  title={isListedStatus
                    ? "Listed — awaiting portal upload"
                    : "Mark as Listed — moves it into My Listings, awaiting portal upload"}
                  className={`flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 ${isListedStatus
                    ? "bg-green-600 text-white border-green-600 cursor-default"
                    : "bg-[#E8F5E9] hover:bg-green-100 text-green-700 border-green-100"
                    } ${isMarkingListed ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <Tag className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">{isMarkingListed ? "Listing…" : "Listed"}</span>
                </button>
              )}
              <PropertyWithdrawControls property={property} onWithdraw={handlePropertyWithdraw} onRelist={handlePropertyRelist}>
                {({ onClick, loading }) => (
                  <button
                    onClick={onClick}
                    disabled={loading}
                    className={`flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 ${
                      property?.is_withdrawn
                        ? "bg-[#E0F2F1] hover:bg-teal-50 text-teal-600 border-teal-100"
                        : "bg-[#FFEBEE] hover:bg-[#FFCDD2] text-[#D32F2F] border-[#FFCDD2]"
                    } ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <Archive className="w-3.5 h-3.5 flex-shrink-0" />
                    <span className="truncate">
                      {property?.is_withdrawn ? "Relist" : "Withdraw"}
                    </span>
                  </button>
                )}
              </PropertyWithdrawControls>
              <button
                onClick={() => setShowSoldModal(true)}
                disabled={isMarkingSold}
                className={`flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 ${
                  property?.is_sold ||
                  property?.status === "Sold" ||
                  property?.status?.name === "Sold"
                    ? "bg-[#E8F5E9] hover:bg-green-50 text-green-600 border-green-100"
                    : "bg-[#E3F2FD] hover:bg-blue-50 text-blue-600 border-blue-100"
                } ${isMarkingSold ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="truncate">
                  {property?.is_sold ||
                  property?.status === "Sold" ||
                  property?.status?.name === "Sold"
                    ? "Mark Unsold"
                    : "Mark as Sold"}
                </span>
              </button>

              {isPropertySold && (
                <button
                  onClick={() => setShowEditSaleModal(true)}
                  disabled={isSavingSale}
                  title="Correct the sold date, price, settlement or commission split"
                  className={`flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 bg-[#F1F8E9] hover:bg-lime-50 text-[#558B2F] border-lime-100 ${isSavingSale ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <Edit2 className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">Edit Sale Details</span>
                </button>
              )}

              {isPropertySold && (
                <button
                  onClick={() => setShowPublishSoldModal(true)}
                  className="flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 bg-cyan-50 hover:bg-cyan-100 text-[#3E9BA4] border-cyan-100"
                >
                  <Send className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">Publish as Sold on Portals</span>
                </button>
              )}

              {isPropertySold && (
                <div className="w-full sm:w-auto sm:min-w-[280px] flex-1">
                  <SoldThroughPortalToggle
                    checked={property?.sold_through_collings_portal}
                    onToggle={handlePortalAttributionToggle}
                  />
                </div>
              )}

              {hasAdminAccess(user) && (
                <button
                  onClick={() => setShowDeleteModal(true)}
                  disabled={isDeleting}
                  className="flex items-center justify-center space-x-2 px-4 sm:px-5 py-2.5 rounded-lg text-[10px] sm:text-xs font-bold transition-all shadow-sm border flex-1 sm:flex-none min-w-0 bg-red-50 hover:bg-red-100 text-red-600 border-red-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <Trash2 className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate">Delete</span>
                </button>
              )}

              <ConfirmModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteProperty}
                loading={isDeleting}
                title="Move to Trash"
                description={`"${property?.address}" will be moved to trash. You can restore it within 90 days before it is permanently deleted.`}
                confirmText="Move to Trash"
                variant="warning"
              />
              {property?.is_sold ||
              property?.status === "Sold" ||
              property?.status?.name === "Sold" ? (
                <ConfirmModal
                  isOpen={showSoldModal}
                  onClose={() => setShowSoldModal(false)}
                  onConfirm={handleToggleSold}
                  loading={isMarkingSold}
                  title="Mark Property as Unsold"
                  description="Are you sure you want to mark this property as unsold? It will be removed from sold properties and commission records will remain."
                  confirmText="Mark Unsold"
                  variant="primary"
                />
              ) : (
                <MarkSoldModal
                  isOpen={showSoldModal}
                  onClose={() => setShowSoldModal(false)}
                  onConfirm={handleToggleSold}
                  loading={isMarkingSold}
                  {...saleModalProps}
                />
              )}

              {isPropertySold && (
                <MarkSoldModal
                  mode="edit"
                  isOpen={showEditSaleModal}
                  onClose={() => setShowEditSaleModal(false)}
                  onConfirm={handleSaveSaleDetails}
                  loading={isSavingSale}
                  {...saleModalProps}
                />
              )}

              <PublishSoldToPortalsModal
                isOpen={showPublishSoldModal}
                onClose={() => setShowPublishSoldModal(false)}
                address={property?.address}
                channels={[
                  { key: "rea", label: "realestate.com.au", sublabel: property?.listing_id || "" },
                  { key: "domain", label: "domain.com.au" },
                  { key: "collings", label: "Collings.com.au" },
                  {
                    key: "website", label: "Collings Portal", disabled: true,
                    disabledReason: "Automatic — follows the listing's method of sale",
                  },
                  { key: "agentpoint", label: "agentpoint", disabled: true, disabledReason: "Not yet connected" },
                  { key: "ratemyagent", label: "RateMyAgent", disabled: true, disabledReason: "Not yet connected" },
                ]}
                reaSoldLocked={Boolean(property?.rea_sold_locked)}
                saleSummary={{
                  soldPrice: property?.sold_price,
                  soldDate: property?.sold_date ?? property?.extra_info?.sold_date,
                  suppressSoldPrice: property?.suppress_sold_price,
                }}
                onPublish={async (selectedChannels, { confirmReaSold } = {}) => {
                  const res = await publishREAPropertySoldToPortals(property.id, selectedChannels, { confirmReaSold });
                  // Pick up the REA lock the push just set.
                  refreshProperty().catch(() => {});
                  return res.data;
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full space-y-10 mt-6">
        <div className="bg-white border-b border-gray-200 px-2 sm:px-6 md:px-8 overflow-x-auto">
          <nav className="flex space-x-6 sm:space-x-12 min-w-max pb-px">
            {[
              { id: "property", label: "Property" },
              { id: "owner", label: "Owner" },
              { id: "purchaser", label: "Purchaser" },
              ...(canViewBuyerData
                ? [{ id: "enquiries", label: `Enquiries / Attendees / Offers (${enquiries.length + bidderRegistrations.length + inspectionAttendees.length + offers.length})` }]
                : []),
              { id: "notes", label: `Agent Notes (${propertyNotes.length})` },
              { id: "documents", label: "Documents" },
              // Compliance file: sale listings only (DOMA 12954696393).
              ...(!isLease ? [{ id: "compliance", label: "Compliance" }] : []),
              {
                id: "buyer_match",
                label: `Buyer Match (${buyerMatches.length})`,
              },
              { id: "activity", label: "Activity" },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`group py-6 px-1 border-b-4 font-black text-xs tracking-[0.15em] transition-all flex items-center uppercase ${
                  activeTab === tab.id
                    ? "border-[#55C5D0] text-[#55C5D0]"
                    : "border-transparent text-[#374151] opacity-50 hover:opacity-100"
                }`}
              >
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        <div className="pb-20 px-4 sm:px-6 md:px-8">
          {activeTab === "property" && renderPropertyTab()}
          {activeTab === "owner" && (
            <div className="animate-in zoom-in-95 duration-500 space-y-8">
              <div className="bg-white border border-gray-100 p-6 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-[#374151] mb-1">
                    Property Owners
                  </h3>
                  <p className="text-xs text-[#374151] opacity-60 font-medium">
                    Manage property owners and their information
                  </p>
                </div>
                <button
                  onClick={() => setShowOwnerModal(true)}
                  className="flex items-center gap-2 px-5 py-2.5 bg-[#55C5D0] text-white rounded-lg text-xs font-bold uppercase tracking-wide shadow-lg shadow-cyan-100 hover:bg-[#4AADB7] transition-all"
                >
                  <Plus className="w-4 h-4" />
                  <span>Add Owner</span>
                </button>
              </div>
              <div className="space-y-4 px-8">
                {owners.map((owner, idx) => {
                  const ownerPhone = owner.contact || owner.phone;
                  const ownerEmail = owner.email?.trim() || "";
                  return (
                    <div
                      key={owner.id || idx}
                      className="bg-white border border-gray-100 rounded-xl p-6 flex items-center justify-between hover:border-[#55C5D0]/30 transition-all group shadow-sm"
                    >
                      <div className="flex items-center space-x-5">
                        <div className="w-12 h-12 bg-[#55C5D0] rounded-full flex items-center justify-center text-white shadow-sm shrink-0">
                          <User className="w-6 h-6" />
                        </div>
                        <div className="space-y-0.5">
                          <div className="flex items-center gap-2">
                            <ContactLink
                              identity={{ email: ownerEmail, name: owner.name, phone: ownerPhone }}
                              returnTo={`/collings-properties/${params.id}?tab=owner`}
                              returnLabel={property?.address || property?.title || 'Property'}
                              className="text-sm font-bold text-[#374151] hover:text-[#3a99a3] hover:underline transition-colors"
                            >
                              {owner.name}
                            </ContactLink>
                            {owner.isPrimary && (
                              <span className="text-[9px] font-bold uppercase tracking-wide px-2 py-0.5 bg-[#55C5D0]/10 text-[#55C5D0] rounded-full">
                                Primary
                              </span>
                            )}
                          </div>
                          {owner.preferred_name && (
                            <p className="text-[11px] text-[#374151] opacity-60 font-medium italic">
                              goes by {owner.preferred_name}
                            </p>
                          )}
                          <p className="text-[11px] text-[#374151] opacity-60 font-medium">
                            {ownerEmail || "No email"}
                          </p>
                          <p className="text-[11px] text-[#374151] opacity-60 font-medium">
                            {ownerPhone || "No phone"}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        {ownerPhone ? (
                          <a
                            href={`tel:${ownerPhone.replace(/\s/g, "")}`}
                            className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors"
                          >
                            <Phone className="w-4 h-4" />
                          </a>
                        ) : (
                          <span
                            className="p-2 text-gray-300 cursor-not-allowed"
                            title="No phone"
                          >
                            <Phone className="w-4 h-4" />
                          </span>
                        )}
                        {ownerEmail ? (
                          <a
                            href={`mailto:${ownerEmail}`}
                            className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors"
                          >
                            <Mail className="w-4 h-4" />
                          </a>
                        ) : (
                          <span
                            className="p-2 text-gray-300 cursor-not-allowed"
                            title="No email"
                          >
                            <Mail className="w-4 h-4" />
                          </span>
                        )}
                        <button
                          onClick={() => handleDeleteOwner(owner)}
                          className="p-2 text-red-400 hover:bg-red-50 rounded-full transition-colors"
                          title="Remove owner"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  );
                })}
                {owners.length === 0 && (
                  <div className="text-center py-16 border-2 border-dashed border-gray-100 rounded-xl">
                    <p className="text-sm text-[#374151] opacity-50 font-medium">
                      No owners added yet. Click "Add Owner" to get started.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          {activeTab === "purchaser" && (
            <div className="animate-in zoom-in-95 duration-500 space-y-8">
              <div className="bg-white border border-gray-100 p-6 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-[#374151] mb-1">
                    Property Purchaser
                  </h3>
                  <p className="text-xs text-[#374151] opacity-60 font-medium">
                    Manage property purchaser and their information
                  </p>
                </div>
                <button
                  onClick={() => {
                    setEditingPurchaser(null);
                    setShowPurchaserModal(true);
                  }}
                  className="flex items-center gap-2 px-5 py-2.5 bg-[#55C5D0] text-white rounded-lg text-xs font-bold uppercase tracking-wide shadow-lg shadow-cyan-100 hover:bg-[#4AADB7] transition-all"
                >
                  <Plus className="w-4 h-4" />
                  <span>Add Purchaser</span>
                </button>
              </div>
              <div className="space-y-4 px-8">
                {purchasers.map((purchaser, idx) => {
                  const purchaserPhone = purchaser.contact || purchaser.phone;
                  const purchaserEmail = purchaser.email?.trim() || "";
                  return (
                    <div
                      key={idx}
                      className="bg-white border border-gray-100 rounded-xl p-6 flex items-center justify-between hover:border-[#55C5D0]/30 transition-all group shadow-sm"
                    >
                      <div className="flex items-center space-x-5">
                        <div className="w-12 h-12 bg-[#55C5D0] rounded-full flex items-center justify-center text-white shadow-sm shrink-0">
                          <User className="w-6 h-6" />
                        </div>
                        <div className="space-y-0.5">
                          <p className="text-sm font-bold text-[#374151]">
                            {purchaser.name}
                          </p>
                          <p className="text-[11px] text-[#374151] opacity-60 font-medium">
                            {purchaserEmail || "No email"}
                          </p>
                          <p className="text-[11px] text-[#374151] opacity-60 font-medium">
                            {purchaserPhone || "No phone"}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        {purchaserPhone ? (
                          <a
                            href={`tel:${purchaserPhone.replace(/\s/g, "")}`}
                            className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors"
                          >
                            <Phone className="w-4 h-4" />
                          </a>
                        ) : (
                          <span
                            className="p-2 text-gray-300 cursor-not-allowed"
                            title="No phone"
                          >
                            <Phone className="w-4 h-4" />
                          </span>
                        )}
                        {purchaserEmail ? (
                          <a
                            href={`mailto:${purchaserEmail}`}
                            className="p-2 text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors"
                          >
                            <Mail className="w-4 h-4" />
                          </a>
                        ) : (
                          <span
                            className="p-2 text-gray-300 cursor-not-allowed"
                            title="No email"
                          >
                            <Mail className="w-4 h-4" />
                          </span>
                        )}
                        {isAdmin && (
                          <>
                            <button
                              onClick={() => handleEditPurchaser(purchaser)}
                              disabled={isUpdating}
                              className="p-2 text-gray-400 hover:text-[#55C5D0] hover:bg-[#E0F7FA] rounded-full transition-colors disabled:opacity-50"
                              title="Edit purchaser"
                            >
                              <Edit className="w-4 h-4" />
                            </button>
                            <button
                              onClick={handleDeletePurchaser}
                              disabled={isUpdating}
                              className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors disabled:opacity-50"
                              title="Delete purchaser"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
                {purchasers.length === 0 && (
                  <div className="flex flex-col items-center justify-center py-20 text-center border-2 border-dashed border-gray-100 rounded-xl bg-gray-50/50">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
                      <User className="w-8 h-8 text-[#55C5D0]" />
                      <Users2 className="w-8 h-8 text-[#55C5D0]" />
                    </div>
                    <h4 className="text-sm font-bold text-[#374151] mb-1">
                      No Purchasers Yet
                    </h4>
                    <p className="text-xs text-[#374151] opacity-50 font-medium mb-6 max-w-xs mx-auto">
                      Add a purchaser to track sales information and contract
                      details for this property.
                    </p>
                    <button
                      onClick={() => {
                        setEditingPurchaser(null);
                        setShowPurchaserModal(true);
                      }}
                      className="flex items-center gap-2 px-6 py-3 bg-[#55C5D0] text-white rounded-xl text-xs font-black uppercase tracking-widest shadow-xl shadow-cyan-100 hover:bg-[#4AADB7] transition-all"
                    >
                      <Plus className="w-4 h-4" />
                      <span>Add First Purchaser</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          {activeTab === "enquiries" && canViewBuyerData && (
            <div className="space-y-6">
              {/* Sub-tabs: Enquiries / Attendees / Offers */}
              <div className="flex items-center gap-1 border-b border-gray-100 overflow-x-auto overflow-y-hidden -mx-4 px-4 sm:mx-0 sm:px-0">
                {[
                  { id: "enquiries", label: "Enquiries", icon: Mail, count: enquiries.length + bidderRegistrations.length },
                  { id: "attendees", label: "Attendees", icon: Users2, count: inspectionAttendees.length },
                  { id: "offers", label: "Offers", icon: DollarSign, count: offers.length },
                ].map((st) => {
                  const Icon = st.icon;
                  const active = enquiriesSubTab === st.id;
                  return (
                    <button
                      key={st.id}
                      onClick={() => setEnquiriesSubTab(st.id)}
                      className={`shrink-0 whitespace-nowrap px-5 py-3 text-sm font-semibold rounded-t-lg transition-all ${active
                        ? "text-[#55C5D0] border-b-2 border-[#55C5D0] -mb-px bg-[#f0fafb]"
                        : "text-gray-500 hover:text-gray-700"
                        }`}
                    >
                      <span className="flex items-center gap-2">
                        <Icon className="w-4 h-4" />
                        {st.label}
                        {st.count > 0 && (
                          <span className="ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold bg-[#55C5D0] text-white shadow-sm">
                            {st.count > 99 ? "99+" : st.count}
                          </span>
                        )}
                      </span>
                    </button>
                  );
                })}
              </div>

              {enquiriesSubTab === "enquiries" && (
              <div className="space-y-6">
              {interactionsLoading ? (
                <div className="bg-white rounded-2xl border border-gray-200 p-20 flex flex-col items-center justify-center shadow-sm">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#55C5D0]"></div>
                  <p className="mt-4 text-sm text-gray-500">
                    Loading enquiries...
                  </p>
                </div>
              ) : enquiries.length === 0 && bidderRegistrations.length === 0 ? (
                <div className="bg-white rounded-2xl border border-gray-200 p-32 flex flex-col items-center justify-center text-center shadow-sm">
                  <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                    <Users2 className="w-8 h-8 text-[#374151] opacity-20" />
                  </div>
                  <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">
                    No Enquiries
                  </h4>
                  <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[250px]">
                    No enquiries recorded for this property.
                  </p>
                </div>
              ) : (
                <>
                  {/* Enquiries Section */}
                  {enquiries.length > 0 && (
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-transparent flex items-center justify-between flex-wrap gap-3">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                          Enquiries ({enquiries.length})
                        </h3>
                        <button
                          type="button"
                          onClick={() => openBulkCommunicator('enquiries')}
                          title="Text or email these enquiries from your own apps"
                          className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                        >
                          <MessageSquare size={14} />
                          Bulk Communicator
                        </button>
                      </div>
                      <div className="divide-y divide-gray-100">
                        {enquiries.map((enq) => (
                          <div
                            key={enq.id}
                            onClick={() => {
                              setEditingEnquiry(enq);
                            }}
                            className="p-6 hover:bg-gray-50 transition-colors cursor-pointer group"
                          >
                            <div className="flex justify-between items-start">
                              <div className="space-y-2 flex-1">
                                <div className="flex items-center gap-3">
                                  <ContactLink
                                    identity={{ email: enq.email, name: enq.name, phone: enq.phone }}
                                    returnTo={`/collings-properties/${params.id}?tab=enquiries&subtab=${enquiriesSubTab}`}
                                    returnLabel={property?.address || property?.title || 'Property'}
                                    className="text-base font-bold text-[#374151] hover:text-[#3a99a3] hover:underline transition-colors"
                                  >
                                    {enq.name}
                                  </ContactLink>
                                  <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
                                    {enq.type_display}
                                  </span>
                                </div>
                                <div className="flex items-center gap-4 text-sm text-gray-500">
                                  <a
                                    href={`mailto:${enq.email}`}
                                    onClick={(e) => e.stopPropagation()}
                                    className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors"
                                  >
                                    <Mail size={14} /> {enq.email}
                                  </a>
                                  {enq.phone && (
                                    <a
                                      href={`tel:${enq.phone}`}
                                      onClick={(e) => e.stopPropagation()}
                                      className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors"
                                    >
                                      <Phone size={14} /> {enq.phone}
                                    </a>
                                  )}
                                </div>
                              </div>
                              <div className="self-center pl-3 flex items-center gap-2">
                                <ContactNotesButton
                                  suggestPreferences={!isLease}
                                  identity={{ email: enq.email, name: enq.name, phone: enq.phone }}
                                  label="Notes"
                                  className="text-xs flex items-center gap-1.5 bg-white hover:bg-amber-50 text-amber-600 border border-amber-300 font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                />
                                <button
                                  onClick={(e) => { e.stopPropagation(); setPrefsPerson({ email: enq.email, name: enq.name, phone: enq.phone }); }}
                                  title="Edit buying preferences"
                                  className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 text-[#3a99a3] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                >
                                  <SlidersHorizontal size={14} /> Preferences
                                </button>
                              </div>
                            </div>
                            {/* Full-width so the enquiry message reads left-to-right
                                rather than squeezed into the narrow info column beside
                                the buttons (CRM-2026-00065). */}
                            <div className="relative mt-2">
                              <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg pr-10">
                                {enq.message}
                              </p>
                              {enq.agent_notes && (
                                <div className="mt-2 p-3 bg-amber-50 border border-amber-100 rounded-lg">
                                  <span className="text-[10px] font-bold text-amber-600 uppercase tracking-widest block mb-1">
                                    Internal agent notes:
                                  </span>
                                  <p className="text-xs text-amber-800 whitespace-pre-wrap">
                                    {enq.agent_notes}
                                  </p>
                                </div>
                              )}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setEditingEnquiry(enq);
                                }}
                                className="absolute top-2 right-2 p-1.5 text-gray-400 hover:text-[#55C5D0] hover:bg-[#55C5D0]/10 rounded-lg transition-all opacity-0 group-hover:opacity-100"
                                title="Edit Enquiry Message"
                              >
                                <Edit size={14} />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {/* Bidder Registrations Section */}
                  {bidderRegistrations.length > 0 && (
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden mt-8">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-orange-50 to-transparent">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                          Bidder Registrations ({bidderRegistrations.length})
                        </h3>
                      </div>
                      <div className="divide-y divide-gray-100">
                        {bidderRegistrations.map((bidder) => (
                          <div key={bidder.id} className="p-6">
                            <div className="flex justify-between items-center">
                              <div className="space-y-1">
                                <p className="text-sm font-bold text-[#374151]">
                                  {bidder.first_name} {bidder.last_name}
                                </p>
                                <p className="text-xs text-gray-500">
                                  {bidder.email} • {bidder.phone}
                                </p>
                              </div>
                              <span className="px-3 py-1 bg-orange-50 text-orange-600 text-[10px] font-bold rounded-lg border border-orange-100 uppercase">
                                Registered
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
              </div>
              )}

              {enquiriesSubTab === "attendees" && (
                <div className="space-y-6">
                  {interactionsLoading ? (
                    <div className="bg-white rounded-2xl border border-gray-200 p-20 flex flex-col items-center justify-center shadow-sm">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#55C5D0]"></div>
                      <p className="mt-4 text-sm text-gray-500">Loading attendees...</p>
                    </div>
                  ) : inspectionAttendees.length === 0 ? (
                    <div className="bg-white rounded-2xl border border-gray-200 p-32 flex flex-col items-center justify-center text-center shadow-sm">
                      <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                        <Users2 className="w-8 h-8 text-[#374151] opacity-20" />
                      </div>
                      <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">No Attendees</h4>
                      <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[280px]">
                        Buyers who check-in to an Open For Inspection for this property will appear here.
                      </p>
                    </div>
                  ) : (
                    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                      <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#55C5D0]/10 to-transparent flex items-center justify-between flex-wrap gap-3">
                        <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                          <span className="w-2 h-2 bg-[#55C5D0] rounded-full"></span>
                          Inspection Register ({inspectionAttendees.length})
                        </h3>
                        <button
                          type="button"
                          onClick={() => openBulkCommunicator('attendees')}
                          title="Text these buyers from your own number"
                          className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                        >
                          <MessageSquare size={14} />
                          Bulk Communicator
                        </button>
                      </div>
                      <div className="divide-y divide-gray-100">
                        {inspectionAttendees.map((att) => {
                          const interestColor =
                            att.interest_level === "very_high" ? "bg-emerald-100 text-emerald-700" :
                            att.interest_level === "high" ? "bg-green-100 text-green-700" :
                            att.interest_level === "medium" ? "bg-blue-100 text-blue-700" :
                            "bg-gray-100 text-gray-700";
                          return (
                            <div key={att.id} className="p-6 hover:bg-gray-50 transition-colors">
                              <div className="flex justify-between items-start gap-4">
                                <div className="space-y-2 flex-1 min-w-0">
                                  <div className="flex items-center gap-3 flex-wrap">
                                    <button
                                      type="button"
                                      onClick={() => handleViewAttendeeContact(att)}
                                      title="Open this attendee's contact profile"
                                      className="text-base font-bold text-[#374151] hover:text-[#55C5D0] hover:underline transition-colors text-left"
                                    >
                                      {att.name}
                                    </button>
                                    {att.interest_level && (
                                      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${interestColor}`}>
                                        {(att.interest_level || "").replace("_", " ")}
                                      </span>
                                    )}
                                    {att.is_first_time_buyer && (
                                      <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700">First-time buyer</span>
                                    )}
                                    {att.converted_to_lead && (
                                      <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-purple-100 text-purple-700">Lead created</span>
                                    )}
                                    {renderContractSentBadge(att)}
                                  </div>
                                  <div className="flex items-center gap-4 text-sm text-gray-500 flex-wrap">
                                    {att.email && (
                                      <a href={`mailto:${att.email}`} className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors">
                                        <Mail size={14} /> {att.email}
                                      </a>
                                    )}
                                    {att.phone && (
                                      <a href={`tel:${att.phone}`} className="flex items-center gap-1 hover:text-[#55C5D0] transition-colors">
                                        <Phone size={14} /> {att.phone}
                                      </a>
                                    )}
                                  </div>
                                  <div className="flex items-center gap-4 text-xs text-gray-400 flex-wrap">
                                    {att.inspection_date && (
                                      <span className="flex items-center gap-1"><Calendar size={12} /> OFI {formatMelbourneDateTime(att.inspection_date)}</span>
                                    )}
                                    {att.budget_range && <span>Budget: {att.budget_range}</span>}
                                    {att.timeline && <span>Timeline: {att.timeline}</span>}
                                  </div>
                                  {/* The buyer's stated feedback on this property, read-only.
                                      Labelled so it is not mistaken for a note - notes live in the
                                      append-only thread behind the Notes button, and nothing on this
                                      row overwrites another agent's text any more. */}
                                  {att.feedback && (
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                      <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-0.5">Buyer feedback</p>
                                      <p className="text-sm text-gray-600 whitespace-pre-wrap break-words">{att.feedback}</p>
                                    </div>
                                  )}
                                  <div className="pt-1 flex items-center gap-2 flex-wrap">
                                    <button
                                      type="button"
                                      onClick={() => handleSendContractToAttendee(att)}
                                      disabled={!att.email || sendingContractAttendeeId === att.id}
                                      title={att.email ? "Email this buyer the Contract of Sale" : "No email on file for this buyer"}
                                      className="text-xs flex items-center gap-1.5 bg-[#55C5D0] hover:bg-[#47b1bb] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <FileText size={14} />
                                      {sendingContractAttendeeId === att.id
                                        ? "Sending…"
                                        : att.contract_sent_count > 0 ? "Resend Contract" : "Send Contract"}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => handleSendPortalSignupToAttendee(att)}
                                      disabled={!att.email || invitingAttendeeId === att.id}
                                      title={att.email ? "Email this buyer a buyer-portal sign-up link" : "No email on file for this buyer"}
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 disabled:opacity-50 disabled:cursor-not-allowed text-[#55C5D0] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <UserPlus size={14} />
                                      {invitingAttendeeId === att.id ? "Sending…" : "Send Portal Sign Up Link"}
                                    </button>
                                    <ContactNotesButton
                                      suggestPreferences={!isLease}
                                      /* attendeeId routes this through the attendee
                                         notes endpoint — the same thread the Open
                                         Home tab writes to. */
                                      identity={{ attendeeId: att.id, contactId: att.contact, email: att.email, name: att.name, phone: att.phone }}
                                      label="Notes"
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-amber-50 text-amber-600 border border-amber-300 font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    />
                                    <button
                                      onClick={(e) => { e.stopPropagation(); setPrefsPerson({ email: att.email, name: att.name, phone: att.phone }); }}
                                      title="Edit buying preferences"
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-[#55C5D0]/10 text-[#3a99a3] border border-[#55C5D0] font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <SlidersHorizontal size={14} /> Preferences
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => setEditingAttendee(att)}
                                      title="Edit this attendee's details"
                                      className="text-xs flex items-center gap-1.5 bg-white hover:bg-gray-50 text-gray-600 border border-gray-300 font-bold uppercase tracking-wider rounded-lg px-3 py-2 transition-colors"
                                    >
                                      <Edit size={14} /> Edit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {showBulkCommunicator && (
                    <BulkCommunicatorModal
                      attendees={bulkConfig.recipients}
                      loadMessages={bulkConfig.loadMessages}
                      markHandedOff={bulkConfig.markHandedOff}
                      emailHandlers={bulkConfig.emailHandlers}
                      scopeKey={bulkContext || 'attendees'}
                      onClose={() => setShowBulkCommunicator(false)}
                    />
                  )}

                  {editingAttendee && (
                    <EditAttendeeModal
                      attendee={editingAttendee}
                      onClose={() => setEditingAttendee(null)}
                      onSaved={(updated) =>
                        setInspectionAttendees((prev) =>
                          prev.map((a) => (a.id === updated.id ? { ...a, ...updated } : a)),
                        )
                      }
                    />
                  )}
                </div>
              )}
            </div>
          )}

          {activeTab === "enquiries" && enquiriesSubTab === "offers" && canViewBuyerData && (
            <div className="space-y-6">
              {interactionsLoading ? (
                <div className="bg-white rounded-2xl border border-gray-200 p-20 flex flex-col items-center justify-center shadow-sm">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#55C5D0]"></div>
                  <p className="mt-4 text-sm text-gray-500">
                    Loading offers...
                  </p>
                </div>
              ) : offers.length === 0 ? (
                <div className="bg-white rounded-2xl border border-gray-200 p-32 flex flex-col items-center justify-center text-center shadow-sm">
                  <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
                    <DollarSign className="w-8 h-8 text-[#374151] opacity-20" />
                  </div>
                  <h4 className="text-xl font-black text-[#374151] mb-2 uppercase tracking-widest">
                    No Offers
                  </h4>
                  <p className="text-[#374151] opacity-50 font-bold text-xs uppercase tracking-widest max-w-[250px]">
                    No offers received for this property yet.
                  </p>
                </div>
              ) : (
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
                  <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-emerald-50 to-transparent flex items-center justify-between flex-wrap gap-3">
                    <h3 className="text-sm font-bold text-[#374151] uppercase tracking-wider flex items-center gap-2">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full"></span>
                      Property Offers ({offers.length})
                    </h3>
                    {vendorStatus && (
                      <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider">
                        <span className="text-gray-400">Vendor portal:</span>
                        {vendorStatus.state === "active" && (
                          <span className="px-2 py-1 rounded-md bg-emerald-50 text-emerald-700 border border-emerald-100">
                            Active · {vendorStatus.vendor?.email}
                          </span>
                        )}
                        {vendorStatus.state === "pending" && (
                          <>
                            <span className="px-2 py-1 rounded-md bg-amber-50 text-amber-700 border border-amber-100">
                              Pending invite · {vendorStatus.vendor?.email}
                            </span>
                            <button
                              type="button"
                              disabled={resendingVendorInvite}
                              onClick={async () => {
                                setResendingVendorInvite(true);
                                try {
                                  const res = await resendPropertyVendorInvite(
                                    params.id,
                                  );
                                  toast.success("Invite re-sent");
                                  setVendorStatus((prev) => ({
                                    ...(prev || {}),
                                    state: res?.data?.vendor?.is_pending_activation
                                      ? "pending"
                                      : "active",
                                    vendor: res?.data?.vendor || prev?.vendor,
                                  }));
                                } catch (err) {
                                  const msg =
                                    err?.response?.data?.detail ||
                                    "Failed to resend invite";
                                  toast.error(msg);
                                } finally {
                                  setResendingVendorInvite(false);
                                }
                              }}
                              className="px-2 py-1 rounded-md border border-amber-200 text-amber-700 hover:bg-amber-100 transition-colors disabled:opacity-50"
                            >
                              {resendingVendorInvite ? "Sending..." : "Resend"}
                            </button>
                          </>
                        )}
                        {vendorStatus.state === "not_invited" && (
                          <>
                            <span className="px-2 py-1 rounded-md bg-gray-50 text-gray-500 border border-gray-100">
                              Not invited
                            </span>
                            {vendorStatus.owner_email && (
                              <button
                                type="button"
                                disabled={resendingVendorInvite}
                                onClick={async () => {
                                  setResendingVendorInvite(true);
                                  try {
                                    const res =
                                      await resendPropertyVendorInvite(
                                        params.id,
                                      );
                                    toast.success("Invite sent");
                                    setVendorStatus((prev) => ({
                                      ...(prev || {}),
                                      state: "pending",
                                      vendor: res?.data?.vendor || null,
                                    }));
                                  } catch (err) {
                                    const msg =
                                      err?.response?.data?.detail ||
                                      "Failed to send invite";
                                    toast.error(msg);
                                  } finally {
                                    setResendingVendorInvite(false);
                                  }
                                }}
                                className="px-2 py-1 rounded-md border border-[#55C5D0]/40 text-[#55C5D0] hover:bg-[#55C5D0]/10 transition-colors disabled:opacity-50"
                              >
                                {resendingVendorInvite ? "Sending..." : "Send invite"}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="divide-y divide-gray-100">
                    {offers.map((offer) => (
                      <div
                        key={offer.id}
                        className="p-8 hover:bg-[#f0fafb]/40 transition-colors cursor-pointer group"
                        onClick={() => setViewingOffer(offer)}
                      >
                        <div className="flex justify-between items-start">
                          <div className="space-y-4 flex-1">
                            {/* Header: Name & Amount */}
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-full bg-[#55C5D0] flex items-center justify-center text-white font-black text-lg shadow-sm">
                                  {offer.buyer_name
                                    ? offer.buyer_name[0].toUpperCase()
                                    : "?"}
                                </div>
                                <div>
                                  <h4 className="text-lg font-black text-[#374151]">
                                    <ContactLink
                                      identity={{ email: offer.buyer_email, name: offer.buyer_name, phone: offer.buyer_phone }}
                                      returnTo={`/collings-properties/${params.id}?tab=enquiries&subtab=offers`}
                                      returnLabel={property?.address || property?.title || 'Property'}
                                      className="text-left text-[#374151] hover:text-[#3a99a3] hover:underline transition-colors"
                                    >
                                      {offer.buyer_name}
                                    </ContactLink>
                                  </h4>
                                  <p className="text-xs font-bold text-[#55C5D0] uppercase tracking-widest">
                                    {offer.reference_number}
                                  </p>
                                </div>
                              </div>
                              <div className="text-right">
                                <div className="text-2xl font-black text-[#55C5D0]">
                                  {offer.offer_amount
                                    ? `$${Number(offer.offer_amount).toLocaleString()}`
                                    : offer.offer_amount_min
                                      ? `$${Number(offer.offer_amount_min).toLocaleString()}`
                                      : "N/A"}
                                </div>
                                <span
                                  className={`text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-md border ${offerStatusPillClasses(offer.status)}`}
                                >
                                  {offerStatusLabel(
                                    offer.status,
                                    offer.status_display,
                                  )}
                                </span>
                              </div>
                            </div>

                            {/* Contact & Settlement */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl border border-gray-100 group-hover:bg-white transition-colors">
                              <div className="space-y-2">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                  Contact Information
                                </span>
                                <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                  <Mail size={14} className="text-[#55C5D0]" />{" "}
                                  {offer.buyer_email}
                                </div>
                                <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                  <Phone size={14} className="text-[#55C5D0]" />{" "}
                                  {offer.buyer_phone || "No phone"}
                                </div>
                              </div>
                              <div className="space-y-2">
                                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                  Settlement & Deposit
                                </span>
                                <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                  <Calendar
                                    size={14}
                                    className="text-[#55C5D0]"
                                  />{" "}
                                  {offer.custom_settlement_date
                                    ? moment(
                                        offer.custom_settlement_date,
                                      ).format("D MMM YYYY")
                                    : `${offer.settlement_days || 30} Days`}
                                  {offer.custom_settlement_date && (
                                    <span className="opacity-50 ml-1">
                                      ({offer.settlement_days} Days)
                                    </span>
                                  )}
                                  {!offer.custom_settlement_date &&
                                    !offer.settlement_days && (
                                      <span className="opacity-50 ml-1">
                                        (
                                        {offer.preferred_settlement_period ||
                                          "Standard"}
                                        )
                                      </span>
                                    )}
                                </div>
                                <div className="flex items-center gap-2 text-xs font-bold text-[#374151]">
                                  <div className="w-3.5 h-3.5 flex items-center justify-center text-[10px] font-black text-[#55C5D0] border border-[#55C5D0] rounded-full">
                                    $
                                  </div>
                                  Deposit: $
                                  {Number(
                                    offer.deposit_amount || 0,
                                  ).toLocaleString()}
                                </div>
                              </div>
                            </div>

                            {/* Conditions */}
                            {offer.conditions &&
                              offer.conditions.length > 0 && (
                                <div className="space-y-2">
                                  <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    Conditions
                                  </span>
                                  <div className="flex flex-wrap gap-2">
                                    {offer.conditions.map((cond, i) => (
                                      <span
                                        key={i}
                                        className="px-3 py-1 bg-white border border-gray-200 rounded-lg text-xs font-bold text-[#374151] shadow-sm"
                                      >
                                        {typeof cond === "string"
                                          ? cond
                                          : cond.type?.replace(/_/g, " ") ||
                                            "Condition"}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              )}

                            {/* Message */}
                            {offer.message && (
                              <div className="bg-amber-50/50 p-4 rounded-xl border border-amber-100/50">
                                <span className="text-[10px] font-black text-amber-600 uppercase tracking-widest mb-1 block">
                                  Buyer Message:
                                </span>
                                <p className="text-sm text-gray-700 italic">
                                  "{offer.message}"
                                </p>
                              </div>
                            )}

                            {/* Agent Notes */}
                            {offer.agent_notes && (
                              <div className="bg-[#55C5D0]/5 p-4 rounded-xl border border-[#55C5D0]/10">
                                <span className="text-[10px] font-black text-[#55C5D0] uppercase tracking-widest mb-1 block">
                                  Internal Response / Notes:
                                </span>
                                <p className="text-sm text-gray-700 whitespace-pre-wrap">
                                  {offer.agent_notes}
                                </p>
                              </div>
                            )}

                            {/* Send-flow status pills (Phase 1 — "park before send") */}
                            <div className="flex flex-wrap gap-2 text-[10px] font-bold uppercase tracking-widest">
                              {offer.sent_to_vendor_at ? (
                                <span className="px-2 py-1 rounded-md border bg-amber-50 text-amber-700 border-amber-100">
                                  ✓ Sent to vendor {moment(offer.sent_to_vendor_at).fromNow()}
                                </span>
                              ) : (
                                <span className="px-2 py-1 rounded-md border bg-gray-50 text-gray-500 border-gray-100">
                                  Not yet sent to vendor
                                </span>
                              )}
                              {offer.sent_to_buyer_at ? (
                                <span className="px-2 py-1 rounded-md border bg-emerald-50 text-emerald-700 border-emerald-100">
                                  ✓ Sent to buyer {moment(offer.sent_to_buyer_at).fromNow()}
                                </span>
                              ) : (
                                <span className="px-2 py-1 rounded-md border bg-gray-50 text-gray-500 border-gray-100">
                                  Not yet sent to buyer
                                </span>
                              )}
                            </div>

                            {/* Phase 5 — locked banner when the offer is closed */}
                            {[
                              "ACCEPTED",
                              "REJECTED",
                              "EXPIRED",
                              "WITHDRAWN",
                              "BUYER_WITHDRAWN",
                            ].includes(offer.status) && (
                              <div
                                className={`mt-1 p-3 rounded-xl border-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${
                                  offer.status === "ACCEPTED"
                                    ? "bg-emerald-50 border-emerald-200 text-emerald-800"
                                    : "bg-gray-100 border-gray-200 text-gray-600"
                                }`}
                              >
                                {offer.status === "ACCEPTED" ? (
                                  <>
                                    <CheckCircle2 size={16} />
                                    <span>
                                      Locked — offer accepted, property is
                                      Under Contract.
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <XCircle size={16} />
                                    <span>
                                      Locked — {offerStatusLabel(
                                        offer.status,
                                        offer.status_display,
                                      )}
                                      . No further negotiation possible.
                                    </span>
                                  </>
                                )}
                              </div>
                            )}

                            {/* Action buttons (Phase 1 — Send to vendor / Send to buyer; Phase 5 — Confirm acceptance) */}
                            <div
                              className="flex flex-wrap gap-2 pt-2"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {[
                                "SUBMITTED",
                                "UNDER_REVIEW",
                                "BUYER_COUNTERED",
                              ].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSendingToVendor(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-[#55C5D0] text-white text-xs font-bold uppercase tracking-wider hover:bg-[#4AADB7] transition-colors shadow-sm"
                                >
                                  Send to Vendor
                                </button>
                              )}
                              {[
                                "VENDOR_COUNTERED",
                                "VENDOR_ACCEPTED",
                                "VENDOR_DECLINED",
                                "COUNTER_OFFER",
                              ].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSendingToBuyer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-emerald-700 transition-colors shadow-sm"
                                >
                                  Send to Buyer
                                </button>
                              )}
                              {![
                                "ACCEPTED",
                                "REJECTED",
                                "EXPIRED",
                                "WITHDRAWN",
                                "BUYER_WITHDRAWN",
                              ].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCounteringToBuyer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-orange-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-orange-700 transition-colors shadow-sm"
                                >
                                  Send Counter Offer
                                </button>
                              )}
                              {[
                                "VENDOR_ACCEPTED",
                                "BUYER_ACCEPTED_COUNTER",
                              ].includes(offer.status) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setFinalizingOffer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-emerald-700 text-white text-xs font-bold uppercase tracking-wider hover:bg-emerald-800 transition-colors shadow-sm flex items-center gap-1"
                                >
                                  <CheckCircle2 size={14} />
                                  Confirm Acceptance
                                </button>
                              )}
                              {![
                                "ACCEPTED",
                                "REJECTED",
                                "EXPIRED",
                                "WITHDRAWN",
                                "BUYER_WITHDRAWN",
                              ].includes(offer.status) && (
                                <button
                                  type="button"
                                  disabled={decliningOfferId === offer.id}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeclineOffer(offer);
                                  }}
                                  className="px-4 py-2 rounded-lg bg-red-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-red-700 transition-colors shadow-sm flex items-center gap-1 disabled:opacity-50"
                                >
                                  <XCircle size={14} />
                                  {decliningOfferId === offer.id
                                    ? "Declining..."
                                    : "Decline Offer"}
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setViewingOffer(offer);
                                }}
                                className="px-4 py-2 rounded-lg border-2 border-gray-200 text-gray-700 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 transition-colors"
                              >
                                Update Status / Note
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTimelineOffer(offer);
                                }}
                                className="px-4 py-2 rounded-lg border-2 border-gray-200 text-gray-700 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 transition-colors"
                              >
                                View History
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openContractForOffer(offer);
                                }}
                                className="px-4 py-2 rounded-lg bg-green-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-green-700 transition-colors shadow-sm"
                              >
                                Fill Out Contract
                              </button>
                            </div>
                          </div>
                          <div className="self-center ml-4 p-2 rounded-full bg-gray-50 text-gray-300 group-hover:bg-[#55C5D0]/10 group-hover:text-[#55C5D0] transition-all">
                            <Eye size={20} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === "notes" && (
            <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left: Add Note Form */}
                <div className="space-y-4">
                  <h3 className="text-xl font-black text-[#374151] tracking-tight">
                    Add New Note
                  </h3>
                  <textarea
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    className="w-full border-2 border-gray-100 rounded-xl p-4 bg-gray-50 min-h-[200px] text-[#374151] font-medium text-sm focus:bg-white focus:border-[#55C5D0] transition-all outline-none resize-none"
                    placeholder="Type your note here..."
                  />
                  <div className="flex justify-end">
                    <button
                      onClick={handleSaveNote}
                      disabled={isUpdating || !newNote.trim()}
                      className="px-6 py-2.5 bg-[#2D3139] hover:bg-black text-white rounded-lg text-xs font-bold uppercase tracking-wide transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isUpdating ? "Saving..." : "Add Note"}
                    </button>
                  </div>
                </div>

                {/* Right: Notes + owner comms history */}
                <AgentNotesPanel
                  notes={propertyNotes}
                  comms={ownerComms}
                  loading={notesLoading}
                  subject={property?.address}
                  onDelete={handleDeleteNote}
                  propertyId={property?.id}
                />
              </div>
            </div>
          )}
          {activeTab === "documents" && <PropertyDocumentsPage />}
          {activeTab === "compliance" && <ComplianceTab propertyId={params.id} />}
          {priceReasonModal}
          {activeTab === "activity" && <PropertyActivityLog propertyId={params.id} />}
          {activeTab === "buyer_match" && (
            <div className="bg-white rounded-2xl border border-gray-200 p-12 shadow-sm animate-in zoom-in-95 duration-500">
              <div className="border-b border-gray-100 pb-8 mb-8">
                <h3 className="text-lg font-bold text-[#374151] mb-1">
                  Buyer Matches
                </h3>
                <p className="text-xs text-[#374151] opacity-60 font-medium">
                  Potential buyers whose preferences match this property's
                  attributes.
                </p>
              </div>

              {buyerMatchesLoading ? (
                <div className="flex flex-col items-center justify-center py-20">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#55C5D0]"></div>
                </div>
              ) : buyerMatches.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-20 text-center border-2 border-dashed border-gray-100 rounded-xl bg-gray-50/50">
                  <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-sm mb-6">
                    <Users2 className="w-10 h-10 text-[#55C5D0]" />
                  </div>
                  <h4 className="text-base font-bold text-[#374151] mb-2">
                    No Buyer Matches Found
                  </h4>
                  <p className="text-sm text-[#374151] opacity-50 font-medium mb-8 max-w-md mx-auto leading-relaxed">
                    We currently haven't found any buyers in your database whose
                    criteria specifically match this property.
                  </p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {buyerMatches.map((match) => (
                    <div
                      key={match.id}
                      className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-[#55C5D0]/30 hover:shadow-md transition-all group"
                    >
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 rounded-full bg-white border border-gray-100 flex items-center justify-center overflow-hidden">
                          {match.profile_image ? (
                            <img
                              src={match.profile_image}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <User className="w-6 h-6 text-gray-300" />
                          )}
                        </div>
                        <div>
                          <h4 className="font-bold text-[#374151]">
                            {match.name}
                          </h4>
                          <span className="text-[10px] font-bold text-cyan-600 uppercase tracking-widest">
                            {match.match_score}% Match Score
                          </span>
                        </div>
                      </div>

                      <div className="space-y-3 mb-6">
                        <div className="flex items-center gap-2 text-xs text-gray-500">
                          <Mail size={12} /> {match.email}
                        </div>
                        <div className="flex items-center gap-2 text-xs text-gray-500">
                          <Phone size={12} /> {match.phone}
                        </div>
                      </div>

                      <div className="space-y-2">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-2">
                          Match Reasons:
                        </span>
                        {match.match_reasons?.map((reason, idx) => (
                          <div
                            key={idx}
                            className="flex items-center gap-2 text-[11px] font-medium text-gray-600 bg-white px-3 py-1.5 rounded-lg border border-gray-200/50"
                          >
                            <CheckCircle2
                              size={12}
                              className="text-green-500"
                            />
                            {reason}
                          </div>
                        ))}
                      </div>

                      <Link
                        to={`/leads?id=${match.id}`}
                        className="mt-6 block w-full py-3 bg-white border border-gray-200 text-[#374151] rounded-xl text-[10px] font-black uppercase tracking-widest text-center group-hover:bg-[#374151] group-hover:text-white group-hover:border-[#374151] transition-all"
                      >
                        View Lead Profile
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <AddOwnerModal
        isOpen={showOwnerModal}
        onClose={() => setShowOwnerModal(false)}
        onSave={handleSaveOwner}
        propertyId={params.id}
      />

      <AddPurchaserModal
        isOpen={showPurchaserModal}
        onClose={() => {
          setShowPurchaserModal(false);
          setEditingPurchaser(null);
        }}
        onSave={handleSavePurchaser}
        loading={isUpdating}
        initialData={editingPurchaser}
        propertyId={params.id}
      />

      <DuplicatePropertyModal
        isOpen={showDuplicateModal}
        onClose={() => !isDuplicating && setShowDuplicateModal(false)}
        property={property}
        loading={isDuplicating}
        onSubmit={handleDuplicateProperty}
      />

      <LeadPreviewModal
        isOpen={!!editingEnquiry}
        onClose={() => setEditingEnquiry(null)}
        enquiry={editingEnquiry}
        mode="view_enquiry"
        loading={isUpdatingEnquiry}
        onSaveEnquiry={handleUpdateEnquiry}
        currentUserName={user?.name || user?.email}
        onAddNote={async (finalNotes) => {
          if (!editingEnquiry?.id) return;
          try {
            await updateEnquiry(editingEnquiry.id, { agent_notes: finalNotes });
            setEnquiries((prev) =>
              prev.map((e) =>
                e.id === editingEnquiry.id
                  ? { ...e, agent_notes: finalNotes }
                  : e,
              ),
            );
            setEditingEnquiry((prev) =>
              prev ? { ...prev, agent_notes: finalNotes } : null,
            );
            toast.success("Note added!");
          } catch (err) {
            toast.error("Failed to add note");
          }
        }}
      />

      <LeadPreviewModal
        isOpen={!!viewingOffer}
        onClose={() => setViewingOffer(null)}
        offer={viewingOffer}
        mode="view_offer"
        loading={isUpdatingOffer}
        currentUserName={user?.name || user?.email}
        onSaveOffer={async (formData) => {
          if (!viewingOffer) return;
          setIsUpdatingOffer(true);
          try {
            const { updateOffer } =
              await import("../../../api/propertyManagement");
            const updatePayload = {
              status: formData.status,
              agent_notes: formData.agent_notes,
              offer_amount: formData.offer_amount,
              settlement_days: formData.settlement_days,
              custom_settlement_date: formData.custom_settlement_date || null,
              deposit_amount: formData.deposit_amount,
              counter_amount: formData.counter_amount || null,
            };
            const response = await updateOffer(viewingOffer.id, updatePayload);
            const updatedData = response?.data || updatePayload;
            setOffers((prev) =>
              prev.map((o) =>
                o.id === viewingOffer.id ? { ...o, ...updatedData } : o,
              ),
            );
            toast.success("Offer updated!");
            setViewingOffer(null);
          } catch (err) {
            console.error("Failed to update offer:", err);
            toast.error("Failed to update offer.");
          } finally {
            setIsUpdatingOffer(false);
          }
        }}
        onAddNote={async (finalNotes) => {
          if (!viewingOffer?.id) return;
          try {
            const { updateOffer } =
              await import("../../../api/propertyManagement");
            await updateOffer(viewingOffer.id, { agent_notes: finalNotes });
            setOffers((prev) =>
              prev.map((o) =>
                o.id === viewingOffer.id
                  ? { ...o, agent_notes: finalNotes }
                  : o,
              ),
            );
            setViewingOffer((prev) =>
              prev ? { ...prev, agent_notes: finalNotes } : null,
            );
            toast.success("Note added!");
          } catch (err) {
            toast.error("Failed to add note");
          }
        }}
        onWorkflowOfferUpdated={(o) => {
          if (!o?.id) return;
          setViewingOffer((prev) => (prev?.id === o.id ? { ...prev, ...o } : prev));
          setOffers((prev) => prev.map((x) => (x.id === o.id ? { ...x, ...o } : x)));
        }}
      />

      <SendToVendorModal
        isOpen={!!sendingToVendor}
        offer={sendingToVendor}
        vendorEmail={vendorStatus?.vendor?.email || vendorStatus?.owner_email}
        vendorName={vendorStatus?.vendor?.name}
        vendorPendingActivation={vendorStatus?.state === "pending"}
        onClose={() => setSendingToVendor(null)}
        onSent={(data) => {
          setOffers((prev) =>
            prev.map((o) =>
              o.id === data.id
                ? {
                    ...o,
                    status: data.status,
                    status_display: data.status_display,
                    agent_message_to_vendor: data.agent_message_to_vendor,
                    sent_to_vendor_at: data.sent_to_vendor_at,
                  }
                : o,
            ),
          );
          // If the vendor was just auto-invited, refresh the badge.
          if (vendorStatus?.state === "not_invited") {
            getPropertyVendorStatus(params.id)
              .then((r) => setVendorStatus(r?.data || null))
              .catch(() => {});
          }
        }}
      />

      <SendToBuyerModal
        isOpen={!!sendingToBuyer}
        offer={sendingToBuyer}
        onClose={() => setSendingToBuyer(null)}
        onSent={(data) => {
          setOffers((prev) =>
            prev.map((o) =>
              o.id === data.id
                ? {
                    ...o,
                    status: data.status,
                    status_display: data.status_display,
                    agent_message_to_buyer: data.agent_message_to_buyer,
                    sent_to_buyer_at: data.sent_to_buyer_at,
                  }
                : o,
            ),
          );
        }}
      />

      <CounterToBuyerModal
        isOpen={!!counteringToBuyer}
        offer={counteringToBuyer}
        onClose={() => setCounteringToBuyer(null)}
        onSent={(data) => {
          setOffers((prev) =>
            prev.map((o) =>
              o.id === data.id
                ? {
                    ...o,
                    status: data.status,
                    status_display: data.status_display,
                    counter_amount: data.counter_amount,
                    deposit_amount: data.deposit_amount,
                    settlement_days: data.settlement_days,
                    custom_settlement_date: data.custom_settlement_date,
                    agent_message_to_buyer: data.agent_message_to_buyer,
                    sent_to_buyer_at: data.sent_to_buyer_at,
                  }
                : o,
            ),
          );
        }}
      />

      {/* Phase 4 — full chronological event log */}
      <OfferTimelineModal
        isOpen={!!timelineOffer}
        offer={timelineOffer}
        onClose={() => setTimelineOffer(null)}
      />

      {/* Phase 5 — Confirm mutual acceptance / move to Under Contract */}
      <Dialog
        open={!!finalizingOffer}
        onOpenChange={(open) => !open && setFinalizingOffer(null)}
      >
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Confirm Mutual Acceptance</DialogTitle>
            <DialogDescription>
              {finalizingOffer && (
                <>
                  Move offer{" "}
                  <strong>{finalizingOffer.reference_number}</strong> to{" "}
                  <strong>Accepted</strong> and mark the property as{" "}
                  <strong>Under Contract</strong>. This will automatically
                  expire any other open offers on this listing and notify the
                  buyer and vendor by email. This action cannot be undone here.
                </>
              )}
            </DialogDescription>
          </DialogHeader>
          <div className="py-2">
            <label className="text-xs font-bold uppercase tracking-wider text-gray-600 mb-1 block">
              Optional note (visible to buyer + vendor)
            </label>
            <textarea
              id="finalize-note"
              className="w-full border-2 border-gray-100 rounded-xl p-3 bg-gray-50 min-h-[80px] text-sm focus:bg-white focus:border-emerald-500 transition-all outline-none resize-none"
              placeholder="e.g. Contracts will be issued today."
            />
          </div>
          <DialogFooter className="gap-2">
            <DialogClose asChild>
              <button
                type="button"
                disabled={finalizing}
                className="px-4 py-2 rounded-lg border-2 border-gray-200 text-gray-700 text-xs font-bold uppercase tracking-wider hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </DialogClose>
            <button
              type="button"
              disabled={finalizing}
              onClick={async () => {
                if (!finalizingOffer) return;
                setFinalizing(true);
                try {
                  const note =
                    document.getElementById("finalize-note")?.value || "";
                  const res = await confirmMutualAcceptance(
                    finalizingOffer.id,
                    { note },
                  );
                  const data = res?.data || {};
                  // Refetch to get the freshly-expired siblings
                  try {
                    const refresh = await getPropertyOffers(params.id);
                    setOffers(refresh.data?.results || []);
                  } catch (_) {
                    setOffers((prev) =>
                      prev.map((o) =>
                        o.id === finalizingOffer.id
                          ? {
                              ...o,
                              status: data.status || "ACCEPTED",
                              status_display:
                                data.status_display || "Accepted",
                            }
                          : o,
                      ),
                    );
                  }
                  toast.success(
                    `Offer accepted. Property is now Under Contract${
                      data.expired_other_offers
                        ? `. ${data.expired_other_offers} other offer(s) expired.`
                        : "."
                    }`,
                  );
                  setFinalizingOffer(null);
                } catch (err) {
                  console.error("Mutual acceptance failed:", err);
                  toast.error(
                    err?.response?.data?.detail ||
                      "Failed to confirm mutual acceptance.",
                  );
                } finally {
                  setFinalizing(false);
                }
              }}
              className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-emerald-700 transition-colors disabled:opacity-50"
            >
              {finalizing ? "Confirming…" : "Confirm & Move to Under Contract"}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {prefsPerson && (
        <BuyerPreferencesModal
          identity={prefsPerson}
          title={prefsPerson.name}
          onClose={() => setPrefsPerson(null)}
        />
      )}
    </div>
  );
}
